import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Alert,
  Snackbar,
  Divider,
  Paper,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
  InputAdornment,
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  ContentCopy as CopyIcon,
  Calculate as CalculateIcon,
  LocalShipping as ShippingIcon,
  Refresh as RefreshIcon,
  Print as PrintIcon,
  ViewList as ListIcon,
  Save as SaveIcon,
  History as HistoryIcon,
  Bookmark as BookmarkIcon,
  Close as CloseIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import Fab from '@mui/material/Fab';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';

// ==================== CONSTANTES DE PREÇOS ====================

const PRICES = {
  // Adesivos Personalizados
  adesivos: {
    precoM2: 69.99,
    acrescimoTransparente: 20.00,
    minimoCartao: 34.99,
    minimoPix: 31.49,
    descontoPix: 0.10,
    sangria: 0.15,
  },
  // Adesivos UV
  uv: {
    precoM2: 150.00,
    acabamentoTintaBranca: 29.99,
    minimoCartao: 75.00,
    minimoPix: 67.50,
    descontoPix: 0.10,
    sangria: 0.15,
  },
  // Banners (preço por m²)
  banners: {
    // Preço 50x80cm: R$ 49,99 PIX | R$ 55,54 Cartão (área = 0,40m²)
    precoM2_50x80: 49.99 / 0.40,
    // PROMOÇÃO 50x80cm: R$ 39,99 PIX | R$ 44,43 Cartão (área = 0,40m²) => 99.975
    precoM2_50x80_promo: 39.99 / 0.40,
    // Preço promocional: 0,80x1,20m = R$ 80 PIX | R$ 88,88 Cartão
    precoM2Promocional: 80 / 0.96,
    // PROMOÇÃO 0,80x1,20m: R$ 59,99 PIX | R$ 66,65 Cartão (área = 0,96m²) => 62.4896
    precoM2_120x80_promo: 59.99 / 0.96,
    // Preço padrão por m²
    precoM2Padrao: 90.00,
    // Cartão: 88,88 / 80 = 1.111
    fatorCartao: 88.88 / 80,
  },
};

// Materiais disponíveis
const MATERIAIS_ADESIVOS = ['Brilho', 'Fosco', 'Transparente'];
const MATERIAIS_UV = ['Brilho UV', 'Fosco UV', 'Transparente UV', 'Dourado', 'Prata', 'Holográfico'];
const ACABAMENTOS_BANNER = ['Madeirinha', 'Ilhós'];
const TIPOS_PRECO_BANNER = ['Promocional', 'Padrão'];

// Tamanhos UV pré-definidos com quantidades mínimas
const TAMANHOS_UV = [
  { id: '3x3', nome: '3x3cm', quantidadeMinima: 250 },
  { id: '4x4', nome: '4x4cm', quantidadeMinima: 150 },
  { id: '5x5', nome: '5x5cm', quantidadeMinima: 90 },
  { id: '6x6', nome: '6x6cm', quantidadeMinima: 60 },
  { id: '7x7', nome: '7x7cm', quantidadeMinima: 50 },
  { id: '8x8', nome: '8x8cm', quantidadeMinima: 35 },
];

// Preços UV fixos
const PRECOS_UV = {
  pix: 39.99,
  cartao: 44.43,
};

// Pacotes prontos predefinidos (precoTransparente: Cartão R$ 77,00 / PIX R$ 69,30)
const PACOTES_PRONTOS = [
  { id: '2x2', nome: '2x2 cm', quantidade: 1500, precoBrilhoFosco: 55.54, precoTransparente: 77.00 },
  { id: '3x3', nome: '3x3 cm', quantidade: 1000, precoBrilhoFosco: 55.54, precoTransparente: 77.00 },
  { id: '4x4', nome: '4x4 cm', quantidade: 500, precoBrilhoFosco: 55.54, precoTransparente: 77.00 },
  { id: '5x5', nome: '5x5 cm', quantidade: 300, precoBrilhoFosco: 55.54, precoTransparente: 77.00 },
  { id: '6x6', nome: '6x6 cm', quantidade: 200, precoBrilhoFosco: 55.54, precoTransparente: 77.00 },
  { id: '7x7', nome: '7x7 cm', quantidade: 180, precoBrilhoFosco: 55.54, precoTransparente: 77.00 },
  { id: '8x8', nome: '8x8 cm', quantidade: 130, precoBrilhoFosco: 55.54, precoTransparente: 77.00 },
  { id: '9x9', nome: '9x9 cm', quantidade: 100, precoBrilhoFosco: 55.54, precoTransparente: 77.00 },
  { id: '10x10', nome: '10x10 cm', quantidade: 90, precoBrilhoFosco: 55.54, precoTransparente: 77.00 },
  { id: '15x15', nome: '15x15 cm', quantidade: 30, precoBrilhoFosco: 55.54, precoTransparente: 77.00 },
];

// Adesivo Sabor e Validade
const SABOR_VALIDADE_OPCOES = [
  { id: '3x4', nome: '3x4 cm', quantidade: 700, precoCartao: 55.54, precoPix: 49.99, isMilheiro: false },
  { id: '4x5', nome: '4x5 cm', quantidade: 400, precoCartao: 55.54, precoPix: 49.99, isMilheiro: false },
  { id: '4x5milheiro', nome: '4x5 cm - Promoção Milheiro', quantidade: 1000, precoCartao: 144.43, precoPix: 129.99, isMilheiro: true, observacaoMilheiro: 'Apenas 1 arte por pacote' },
];

// Lacres — pacotes prontos (material Brilho)
const LACRES_OPCOES = [
  { id: '4x9',          nome: '4x9 cm - Bolo no pote',                 quantidade: 250,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '4.5x11',       nome: '4,5x11 cm - Lacres para potes',         quantidade: 180,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '3x6',          nome: '3x6 cm - Lacres para sacolas',          quantidade: 200,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '4x8',          nome: '4x8 cm - Lacres para sacolas',          quantidade: 200,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '4x10',         nome: '4x10 cm - New lacre',                   quantidade: 200,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '4x14',         nome: '4x14 cm - Lacres para copos',           quantidade: 150,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '4x15-validade',nome: '4x15 cm - Lacres validade e fabricação',quantidade: 140,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '4x12',         nome: '4x12 cm - Lacres coração',              quantidade: 200,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '5x13.5',       nome: '5x13,5 cm - Lacres feito com amor',     quantidade: 90,   precoPix: 49.99,  precoCartao: 55.54 },
  { id: '5x15',         nome: '5x15 cm - Lacres para pudim',           quantidade: 90,   precoPix: 49.99,  precoCartao: 55.54 },
  { id: '4.5x29',       nome: '4,5x29 cm - Lacres cinta',              quantidade: 60,   precoPix: 49.99,  precoCartao: 55.54 },
  { id: '2.5x7',        nome: '2,5x7 cm - Lacres para brigadeiro',     quantidade: 400,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '4x15-copo',    nome: '4x15 cm - Lacres para mini copo bolha', quantidade: 140,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '3x8.5',        nome: '3x8,5 cm - Mini lacres para sacolas',   quantidade: 250,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '4x15-sabor',   nome: '4x15 cm - Lacres sabor e validade',     quantidade: 140,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '4x25',         nome: '4x25 cm - Lacres horizontais',          quantidade: 100,  precoPix: 49.99,  precoCartao: 55.54 },
  { id: '2x15',         nome: '2x15 cm - Lacres delivery',             quantidade: 1000, precoPix: 184.99, precoCartao: 205.54 },
  { id: '3.5x10',       nome: '3,5x10 cm - Lacre retangular',          quantidade: 1000, precoPix: 184.99, precoCartao: 205.54 },
];

// Pacotes Milheiro (1000 unidades)
const MILHEIRO_PACOTES = [
  { id: '3x3', nome: '3x3 cm', quantidade: 1000, precoPix: 59.99, precoCartao: 66.66 },
  { id: '4x4', nome: '4x4 cm', quantidade: 1000, precoPix: 119.99, precoCartao: 133.32 },
  { id: '5x5', nome: '5x5 cm', quantidade: 1000, precoPix: 169.99, precoCartao: 188.88 },
  { id: '6x6', nome: '6x6 cm', quantidade: 1000, precoPix: 299.99, precoCartao: 333.32 },
  { id: '7x7', nome: '7x7 cm', quantidade: 1000, precoPix: 329.99, precoCartao: 366.65 },
];

// Opções de frete
const OPCOES_FRETE = [
  { id: 'retirada', nome: 'Retirada', valor: 0 },
  { id: 'ecom_loggi', nome: 'Ecom Loggi', valor: 0 },
  { id: 'sedex', nome: 'SEDEX', valor: 0 },
  { id: 'pac', nome: 'PAC', valor: 0 },
  { id: 'total_express', nome: 'Total Express', valor: 0 },
  { id: 'latam_cargo', nome: 'Latam Cargo', valor: 0 },
  { id: 'clube_flex', nome: 'CLUBE FLEX', valor: 0 },
  { id: 'expresso', nome: 'EXPRESSO', valor: 0 },
  { id: 'jet', nome: 'J&T', valor: 0 },
  { id: 'dom', nome: 'DOM', valor: 0 },
  { id: 'personalizado', nome: 'Personalizado', valor: 0 },
];

const TIPOS_ORCAMENTO = [
  'Novo Pedido',
  'Repetição de Pedido',
  'Repetição com Alteração',
  'Básico',
];

// ==================== INTERFACES ====================

interface ItemAdesivo {
  id: string;
  largura: number;
  altura: number;
  quantidade: number;
  material: string;
  observacoes: string;
  area: number;
  precoCartao: number;
  precoPix: number;
}

interface ItemUV {
  id: string;
  tamanhoId: string;
  tamanhoNome: string;
  quantidadeMinima: number;
  quantidadePacotes: number;
  material: string;
  observacoes: string;
  precoCartao: number;
  precoPix: number;
}

interface ItemBanner {
  id: string;
  largura: number;  // em metros
  altura: number;   // em metros
  quantidade: number;
  acabamento: string;
  observacoes: string;
  precoM2: number;  // preço por m² usado (83.34 promo ou 90.00)
  area: number;
  precoCartao: number;
  precoPix: number;
}

interface ItemPacote {
  id: string;
  pacoteId: string;
  pacoteNome: string;
  quantidadePacotes: number;
  material: string;
  observacoes: string;
  quantidadeUnidades: number;
  precoCartao: number;
  precoPix: number;
}

interface ItemMilheiro {
  id: string;
  pacoteId: string;
  pacoteNome: string;
  quantidadePacotes: number;
  material: string;
  observacoes: string;
  quantidadeUnidades: number;
  precoCartao: number;
  precoPix: number;
}

interface ItemSaborValidade {
  id: string;
  opcaoId: string;
  opcaoNome: string;
  quantidadePacotes: number;
  observacoes: string;
  quantidadeUnidades: number;
  precoCartao: number;
  precoPix: number;
  isMilheiro: boolean;
}

interface ItemLacre {
  id: string;
  opcaoId: string;
  opcaoNome: string;
  quantidadePacotes: number;
  observacoes: string;
  quantidadeUnidades: number;
  precoCartao: number;
  precoPix: number;
}

// Interface para orçamentos salvos em cache
interface OrcamentoSalvo {
  id: string;
  nome: string;
  dataSalvo: string;
  itensAdesivos: ItemAdesivo[];
  itensUV: ItemUV[];
  itensBanners: ItemBanner[];
  itensPacotes: ItemPacote[];
  itensMilheiro: ItemMilheiro[];
  itensSaborValidade: ItemSaborValidade[];
  itensLacres?: ItemLacre[];
  freteOpcao: string;
  freteValor: string;
  tipoOrcamento: string;
  observacoesGerais: string;
}

// Interface para tamanhos personalizados
interface TamanhoPersonalizado {
  id: string;
  nome: string;
  largura: number;
  altura: number;
  quantidade: number;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

// ==================== COMPONENTES AUXILIARES ====================

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div hidden={value !== index} {...other}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

// ==================== COMPONENTE PRINCIPAL ====================

const QuickQuote: React.FC = () => {
  // Estados das abas
  const [activeTab, setActiveTab] = useState(0);

  // Estados dos formulários
  const [formAdesivo, setFormAdesivo] = useState({
    largura: '',
    altura: '',
    quantidade: '',
    material: 'Brilho',
    observacoes: '',
  });

  const [formUV, setFormUV] = useState({
    tamanhoId: '3x3',
    quantidadePacotes: '1',
    material: 'Brilho UV',
    observacoes: '',
  });

  const [formBanner, setFormBanner] = useState({
    largura: '0.80',
    altura: '1.20',
    quantidade: '1',
    precoM2: '83.33', // Promocional (0,80x1,20m = R$ 80 PIX, R$ 88,88 Cartão)
    acabamento: 'Ilhós',
    observacoes: '',
  });

  const [formPacote, setFormPacote] = useState({
    pacoteId: '3x3',
    quantidadePacotes: '1',
    material: 'Brilho',
    observacoes: '',
  });

  const [formMilheiro, setFormMilheiro] = useState({
    pacoteId: '3x3',
    quantidadePacotes: '1',
    material: 'Brilho',
    observacoes: '',
  });

  const [formSaborValidade, setFormSaborValidade] = useState({
    opcaoId: '3x4',
    quantidadePacotes: '1',
    observacoes: '',
  });

  const [formLacres, setFormLacres] = useState({
    opcaoId: '4x9',
    quantidadePacotes: '1',
    observacoes: '',
  });

  // Estados das listas de itens
  const [itensAdesivos, setItensAdesivos] = useState<ItemAdesivo[]>([]);
  const [itensUV, setItensUV] = useState<ItemUV[]>([]);
  const [itensBanners, setItensBanners] = useState<ItemBanner[]>([]);
  const [itensPacotes, setItensPacotes] = useState<ItemPacote[]>([]);
  const [itensMilheiro, setItensMilheiro] = useState<ItemMilheiro[]>([]);
  const [itensSaborValidade, setItensSaborValidade] = useState<ItemSaborValidade[]>([]);
  const [itensLacres, setItensLacres] = useState<ItemLacre[]>([]);

  // Estados de preview
  const [previewAdesivo, setPreviewAdesivo] = useState({ area: 0, precoCartao: 0, precoPix: 0 });
  const [previewUV, setPreviewUV] = useState({ unidades: 0, precoCartao: 0, precoPix: 0 });
  const [previewBanner, setPreviewBanner] = useState({ area: 0, precoCartao: 0, precoPix: 0 });
  const [previewPacote, setPreviewPacote] = useState({ precoCartao: 0, precoPix: 0, unidades: 0 });
  const [previewMilheiro, setPreviewMilheiro] = useState({ precoCartao: 0, precoPix: 0, unidades: 0 });
  const [previewSaborValidade, setPreviewSaborValidade] = useState({ precoCartao: 0, precoPix: 0, unidades: 0 });
  const [previewLacres, setPreviewLacres] = useState({ precoCartao: 0, precoPix: 0, unidades: 0 });

  // Estados de frete e orçamento
  const [freteOpcao, setFreteOpcao] = useState('retirada');
  const [freteValor, setFreteValor] = useState('0');
  const [tipoOrcamento, setTipoOrcamento] = useState('Novo Pedido');
  const [observacoesGerais, setObservacoesGerais] = useState('');
  const [considerarTodosItens, setConsiderarTodosItens] = useState(true);

  // Estados de UI
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' as 'success' | 'error' });
  const [openOrcamentoDialog, setOpenOrcamentoDialog] = useState(false);
  const [orcamentoTexto, setOrcamentoTexto] = useState('');

  // Estados de edição
  const [editingAdesivo, setEditingAdesivo] = useState<string | null>(null);
  const [editingUV, setEditingUV] = useState<string | null>(null);
  const [editingBanner, setEditingBanner] = useState<string | null>(null);
  const [editingPacote, setEditingPacote] = useState<string | null>(null);
  const [editingMilheiro, setEditingMilheiro] = useState<string | null>(null);
  const [editingSaborValidade, setEditingSaborValidade] = useState<string | null>(null);
  const [editingLacres, setEditingLacres] = useState<string | null>(null);

  // Estados do menu flutuante e cache
  const [speedDialOpen, setSpeedDialOpen] = useState(false);
  const [orcamentosSalvos, setOrcamentosSalvos] = useState<OrcamentoSalvo[]>([]);
  const [tamanhosPersonalizados, setTamanhosPersonalizados] = useState<TamanhoPersonalizado[]>([]);
  const [dialogTamanhos, setDialogTamanhos] = useState(false);
  const [dialogHistorico, setDialogHistorico] = useState(false);
  const [dialogSalvar, setDialogSalvar] = useState(false);
  const [novoTamanho, setNovoTamanho] = useState({ nome: '', largura: '', altura: '', quantidade: '' });
  const [nomeOrcamento, setNomeOrcamento] = useState('');
  const [editingTamanho, setEditingTamanho] = useState<string | null>(null);

  // Carregar dados do cache ao iniciar
  useEffect(() => {
    const orcamentosSalvosCache = localStorage.getItem('vettorprint_orcamentos');
    const tamanhosCache = localStorage.getItem('vettorprint_tamanhos');
    
    if (orcamentosSalvosCache) {
      try {
        setOrcamentosSalvos(JSON.parse(orcamentosSalvosCache));
      } catch (e) {
        console.error('Erro ao carregar orçamentos:', e);
      }
    }
    
    if (tamanhosCache) {
      try {
        setTamanhosPersonalizados(JSON.parse(tamanhosCache));
      } catch (e) {
        console.error('Erro ao carregar tamanhos:', e);
      }
    }
  }, []);

  // ==================== FUNÇÕES DE CÁLCULO ====================

  // Calcular área com sangria
  const calcularArea = useCallback((largura: number, altura: number, quantidade: number, sangria: number = 0.15): number => {
    const areaUnidade = ((largura + sangria) * (altura + sangria)) / 10000;
    return Number((areaUnidade * quantidade).toFixed(4));
  }, []);

  // Calcular preço de adesivo personalizado
  const calcularPrecoAdesivo = useCallback((area: number, material: string) => {
    let precoBase = area * PRICES.adesivos.precoM2;
    
    if (material === 'Transparente') {
      precoBase += PRICES.adesivos.acrescimoTransparente;
    }

    const precoCartao = Math.max(precoBase, PRICES.adesivos.minimoCartao);
    const precoPix = Math.max(precoCartao * (1 - PRICES.adesivos.descontoPix), PRICES.adesivos.minimoPix);

    return {
      precoCartao: Number(precoCartao.toFixed(2)),
      precoPix: Number(precoPix.toFixed(2)),
    };
  }, []);

  // Calcular preço de adesivo UV
  // Calcular preço UV (preço fixo por pacote)
  const calcularPrecoUV = useCallback((quantidadePacotes: number) => {
    const precoCartao = PRECOS_UV.cartao * quantidadePacotes;
    const precoPix = PRECOS_UV.pix * quantidadePacotes;

    return {
      precoCartao: Number(precoCartao.toFixed(2)),
      precoPix: Number(precoPix.toFixed(2)),
    };
  }, []);

  // Calcular preço de banner (medidas em metros)
  // Conforme documentação: PIX = Área × Preço/m², Cartão = PIX × 1.1112
  const calcularPrecoBanner = useCallback((larguraMetros: number, alturaMetros: number, quantidade: number, precoM2: number) => {
    // Área de uma unidade
    const areaUnidade = larguraMetros * alturaMetros;
    // Área total considerando quantidade
    const areaTotal = areaUnidade * quantidade;
    
    // Preço PIX = Área × Preço por m²
    const precoPix = areaTotal * precoM2;
    
    // Preço Cartão = Preço PIX × 1.1112 (fator de conversão)
    const precoCartao = precoPix * PRICES.banners.fatorCartao;

    return {
      area: Number(areaTotal.toFixed(4)),
      precoCartao: Number(precoCartao.toFixed(2)),
      precoPix: Number(precoPix.toFixed(2)),
    };
  }, []);

  // Calcular preço de pacote
  const calcularPrecoPacote = useCallback((pacoteId: string, quantidadePacotes: number, material: string) => {
    const pacote = PACOTES_PRONTOS.find(p => p.id === pacoteId);
    if (!pacote) return { precoCartao: 0, precoPix: 0, unidades: 0 };

    const precoUnitario = material === 'Transparente' ? pacote.precoTransparente : pacote.precoBrilhoFosco;
    const precoCartao = precoUnitario * quantidadePacotes;
    const precoPix = precoCartao * 0.9;
    const unidades = pacote.quantidade * quantidadePacotes;

    return {
      precoCartao: Number(precoCartao.toFixed(2)),
      precoPix: Number(precoPix.toFixed(2)),
      unidades,
    };
  }, []);

  // Calcular preço Adesivo Sabor e Validade
  const calcularPrecoSaborValidade = useCallback((opcaoId: string, quantidadePacotes: number) => {
    const opcao = SABOR_VALIDADE_OPCOES.find(p => p.id === opcaoId);
    if (!opcao) return { precoCartao: 0, precoPix: 0, unidades: 0 };

    const precoCartao = opcao.precoCartao * quantidadePacotes;
    const precoPix = opcao.precoPix * quantidadePacotes;
    const unidades = opcao.quantidade * quantidadePacotes;

    return {
      precoCartao: Number(precoCartao.toFixed(2)),
      precoPix: Number(precoPix.toFixed(2)),
      unidades,
    };
  }, []);

  // Calcular preço de lacres (pacotes prontos)
  const calcularPrecoLacres = useCallback((opcaoId: string, quantidadePacotes: number) => {
    const opcao = LACRES_OPCOES.find(p => p.id === opcaoId);
    if (!opcao) return { precoCartao: 0, precoPix: 0, unidades: 0 };

    const precoCartao = opcao.precoCartao * quantidadePacotes;
    const precoPix = opcao.precoPix * quantidadePacotes;
    const unidades = opcao.quantidade * quantidadePacotes;

    return {
      precoCartao: Number(precoCartao.toFixed(2)),
      precoPix: Number(precoPix.toFixed(2)),
      unidades,
    };
  }, []);

  // Calcular preço de milheiro (pacotes de 1000 unidades)
  const calcularPrecoMilheiro = useCallback((pacoteId: string, quantidadePacotes: number) => {
    const pacote = MILHEIRO_PACOTES.find(p => p.id === pacoteId);
    if (!pacote) return { precoCartao: 0, precoPix: 0, unidades: 0 };

    const precoCartao = pacote.precoCartao * quantidadePacotes;
    const precoPix = pacote.precoPix * quantidadePacotes;
    const unidades = pacote.quantidade * quantidadePacotes;

    return {
      precoCartao: Number(precoCartao.toFixed(2)),
      precoPix: Number(precoPix.toFixed(2)),
      unidades,
    };
  }, []);

  // ==================== EFEITOS DE PREVIEW ====================

  // Preview Adesivo
  useEffect(() => {
    const largura = parseFloat(formAdesivo.largura) || 0;
    const altura = parseFloat(formAdesivo.altura) || 0;
    const quantidade = parseInt(formAdesivo.quantidade) || 0;

    if (largura > 0 && altura > 0 && quantidade > 0) {
      const area = calcularArea(largura, altura, quantidade, PRICES.adesivos.sangria);
      const precos = calcularPrecoAdesivo(area, formAdesivo.material);
      setPreviewAdesivo({ area, ...precos });
    } else {
      setPreviewAdesivo({ area: 0, precoCartao: 0, precoPix: 0 });
    }
  }, [formAdesivo, calcularArea, calcularPrecoAdesivo]);

  // Preview UV
  useEffect(() => {
    const quantidadePacotes = parseInt(formUV.quantidadePacotes) || 0;
    const tamanho = TAMANHOS_UV.find(t => t.id === formUV.tamanhoId);

    if (quantidadePacotes > 0 && tamanho) {
      const unidades = tamanho.quantidadeMinima * quantidadePacotes;
      const precos = calcularPrecoUV(quantidadePacotes);
      setPreviewUV({ unidades, ...precos });
    } else {
      setPreviewUV({ unidades: 0, precoCartao: 0, precoPix: 0 });
    }
  }, [formUV, calcularPrecoUV]);

  // Preview Banner (medidas em metros)
  useEffect(() => {
    const largura = parseFloat(formBanner.largura.replace(',', '.')) || 0;
    const altura = parseFloat(formBanner.altura.replace(',', '.')) || 0;
    const quantidade = parseInt(formBanner.quantidade) || 1;

    const precoM2 = parseFloat(formBanner.precoM2) || PRICES.banners.precoM2Promocional;
    
    if (largura > 0 && altura > 0) {
      const result = calcularPrecoBanner(largura, altura, quantidade, precoM2);
      setPreviewBanner(result);
    } else {
      setPreviewBanner({ area: 0, precoCartao: 0, precoPix: 0 });
    }
  }, [formBanner, calcularPrecoBanner]);

  // Preview Pacote
  useEffect(() => {
    const quantidadePacotes = parseInt(formPacote.quantidadePacotes) || 0;

    if (quantidadePacotes > 0) {
      const result = calcularPrecoPacote(formPacote.pacoteId, quantidadePacotes, formPacote.material);
      setPreviewPacote(result);
    } else {
      setPreviewPacote({ precoCartao: 0, precoPix: 0, unidades: 0 });
    }
  }, [formPacote, calcularPrecoPacote]);

  // Preview Milheiro
  useEffect(() => {
    const quantidadePacotes = parseInt(formMilheiro.quantidadePacotes) || 0;

    if (quantidadePacotes > 0) {
      const result = calcularPrecoMilheiro(formMilheiro.pacoteId, quantidadePacotes);
      setPreviewMilheiro(result);
    } else {
      setPreviewMilheiro({ precoCartao: 0, precoPix: 0, unidades: 0 });
    }
  }, [formMilheiro, calcularPrecoMilheiro]);

  // Preview Sabor e Validade
  useEffect(() => {
    const quantidadePacotes = parseInt(formSaborValidade.quantidadePacotes) || 0;

    if (quantidadePacotes > 0) {
      const result = calcularPrecoSaborValidade(formSaborValidade.opcaoId, quantidadePacotes);
      setPreviewSaborValidade(result);
    } else {
      setPreviewSaborValidade({ precoCartao: 0, precoPix: 0, unidades: 0 });
    }
  }, [formSaborValidade, calcularPrecoSaborValidade]);

  // Preview Lacres
  useEffect(() => {
    const quantidadePacotes = parseInt(formLacres.quantidadePacotes) || 0;

    if (quantidadePacotes > 0) {
      const result = calcularPrecoLacres(formLacres.opcaoId, quantidadePacotes);
      setPreviewLacres(result);
    } else {
      setPreviewLacres({ precoCartao: 0, precoPix: 0, unidades: 0 });
    }
  }, [formLacres, calcularPrecoLacres]);

  // ==================== FUNÇÕES DE ADICIONAR/REMOVER ITENS ====================

  const gerarId = () => `item_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

  const adicionarAdesivo = () => {
    const largura = parseFloat(formAdesivo.largura);
    const altura = parseFloat(formAdesivo.altura);
    const quantidade = parseInt(formAdesivo.quantidade);

    if (!largura || largura < 3 || largura > 30) {
      setSnackbar({ open: true, message: 'Largura deve estar entre 3 e 30 cm', severity: 'error' });
      return;
    }
    if (!altura || altura < 3 || altura > 30) {
      setSnackbar({ open: true, message: 'Altura deve estar entre 3 e 30 cm', severity: 'error' });
      return;
    }
    if (!quantidade || quantidade < 1 || quantidade > 1000000) {
      setSnackbar({ open: true, message: 'Quantidade deve estar entre 1 e 1.000.000', severity: 'error' });
      return;
    }

    const area = calcularArea(largura, altura, quantidade, PRICES.adesivos.sangria);
    const precos = calcularPrecoAdesivo(area, formAdesivo.material);

    const novoItem: ItemAdesivo = {
      id: gerarId(),
      largura,
      altura,
      quantidade,
      material: formAdesivo.material,
      observacoes: formAdesivo.observacoes,
      area,
      ...precos,
    };

    setItensAdesivos([...itensAdesivos, novoItem]);
    setFormAdesivo({ ...formAdesivo, largura: '', altura: '', quantidade: '', observacoes: '' });
    setSnackbar({ open: true, message: 'Adesivo adicionado!', severity: 'success' });
  };

  const adicionarUV = () => {
    const quantidadePacotes = parseInt(formUV.quantidadePacotes);
    const tamanho = TAMANHOS_UV.find(t => t.id === formUV.tamanhoId);

    if (!quantidadePacotes || quantidadePacotes < 1) {
      setSnackbar({ open: true, message: 'Quantidade deve ser pelo menos 1', severity: 'error' });
      return;
    }

    if (!tamanho) {
      setSnackbar({ open: true, message: 'Selecione um tamanho', severity: 'error' });
      return;
    }

    const precos = calcularPrecoUV(quantidadePacotes);

    const novoItem: ItemUV = {
      id: gerarId(),
      tamanhoId: formUV.tamanhoId,
      tamanhoNome: tamanho.nome,
      quantidadeMinima: tamanho.quantidadeMinima,
      quantidadePacotes,
      material: formUV.material,
      observacoes: formUV.observacoes,
      ...precos,
    };

    setItensUV([...itensUV, novoItem]);
    setFormUV({ ...formUV, quantidadePacotes: '1', observacoes: '' });
    setSnackbar({ open: true, message: 'UV adicionado!', severity: 'success' });
  };

  const adicionarBanner = () => {
    const largura = parseFloat(formBanner.largura.replace(',', '.'));
    const altura = parseFloat(formBanner.altura.replace(',', '.'));
    const quantidade = parseInt(formBanner.quantidade) || 1;
    const precoM2 = parseFloat(formBanner.precoM2) || PRICES.banners.precoM2Promocional;

    if (!largura || largura < 0.10) {
      setSnackbar({ open: true, message: 'Largura mínima: 0,10 m', severity: 'error' });
      return;
    }
    if (!altura || altura < 0.10) {
      setSnackbar({ open: true, message: 'Altura mínima: 0,10 m', severity: 'error' });
      return;
    }

    const result = calcularPrecoBanner(largura, altura, quantidade, precoM2);

    const novoItem: ItemBanner = {
      id: gerarId(),
      largura,
      altura,
      quantidade,
      precoM2,
      acabamento: formBanner.acabamento,
      observacoes: formBanner.observacoes,
      ...result,
    };

    setItensBanners([...itensBanners, novoItem]);
    setFormBanner({ ...formBanner, largura: '0.80', altura: '1.20', quantidade: '1', precoM2: '83.33', observacoes: '' });
    setSnackbar({ open: true, message: 'Banner adicionado!', severity: 'success' });
  };

  const adicionarPacote = () => {
    const quantidadePacotes = parseInt(formPacote.quantidadePacotes);

    if (!quantidadePacotes || quantidadePacotes < 1) {
      setSnackbar({ open: true, message: 'Quantidade de pacotes deve ser pelo menos 1', severity: 'error' });
      return;
    }

    const pacote = PACOTES_PRONTOS.find(p => p.id === formPacote.pacoteId);
    if (!pacote) return;

    const result = calcularPrecoPacote(formPacote.pacoteId, quantidadePacotes, formPacote.material);

    const novoItem: ItemPacote = {
      id: gerarId(),
      pacoteId: formPacote.pacoteId,
      pacoteNome: pacote.nome,
      quantidadePacotes,
      material: formPacote.material,
      observacoes: formPacote.observacoes,
      quantidadeUnidades: result.unidades,
      precoCartao: result.precoCartao,
      precoPix: result.precoPix,
    };

    setItensPacotes([...itensPacotes, novoItem]);
    setFormPacote({ ...formPacote, quantidadePacotes: '1', observacoes: '' });
    setSnackbar({ open: true, message: 'Pacote adicionado!', severity: 'success' });
  };

  const adicionarMilheiro = () => {
    const quantidadePacotes = parseInt(formMilheiro.quantidadePacotes);

    if (!quantidadePacotes || quantidadePacotes < 1) {
      setSnackbar({ open: true, message: 'Quantidade de pacotes deve ser pelo menos 1', severity: 'error' });
      return;
    }

    const pacote = MILHEIRO_PACOTES.find(p => p.id === formMilheiro.pacoteId);
    if (!pacote) return;

    const result = calcularPrecoMilheiro(formMilheiro.pacoteId, quantidadePacotes);

    const novoItem: ItemMilheiro = {
      id: gerarId(),
      pacoteId: formMilheiro.pacoteId,
      pacoteNome: pacote.nome,
      quantidadePacotes,
      material: formMilheiro.material,
      observacoes: formMilheiro.observacoes,
      quantidadeUnidades: result.unidades,
      precoCartao: result.precoCartao,
      precoPix: result.precoPix,
    };

    setItensMilheiro([...itensMilheiro, novoItem]);
    setFormMilheiro({ ...formMilheiro, quantidadePacotes: '1', observacoes: '' });
    setSnackbar({ open: true, message: 'Pacote Milheiro adicionado!', severity: 'success' });
  };

  const adicionarSaborValidade = () => {
    const quantidadePacotes = parseInt(formSaborValidade.quantidadePacotes);

    if (!quantidadePacotes || quantidadePacotes < 1) {
      setSnackbar({ open: true, message: 'Quantidade deve ser pelo menos 1', severity: 'error' });
      return;
    }

    const opcao = SABOR_VALIDADE_OPCOES.find(p => p.id === formSaborValidade.opcaoId);
    if (!opcao) return;

    const result = calcularPrecoSaborValidade(formSaborValidade.opcaoId, quantidadePacotes);

    const novoItem: ItemSaborValidade = {
      id: gerarId(),
      opcaoId: formSaborValidade.opcaoId,
      opcaoNome: opcao.nome,
      quantidadePacotes,
      observacoes: formSaborValidade.observacoes,
      quantidadeUnidades: result.unidades,
      precoCartao: result.precoCartao,
      precoPix: result.precoPix,
      isMilheiro: opcao.isMilheiro,
    };

    setItensSaborValidade([...itensSaborValidade, novoItem]);
    setFormSaborValidade({ ...formSaborValidade, quantidadePacotes: '1', observacoes: '' });
    setSnackbar({ open: true, message: 'Adesivo Sabor e Validade adicionado!', severity: 'success' });
  };

  const adicionarLacre = () => {
    const quantidadePacotes = parseInt(formLacres.quantidadePacotes);

    if (!quantidadePacotes || quantidadePacotes < 1) {
      setSnackbar({ open: true, message: 'Quantidade deve ser pelo menos 1', severity: 'error' });
      return;
    }

    const opcao = LACRES_OPCOES.find(p => p.id === formLacres.opcaoId);
    if (!opcao) return;

    const result = calcularPrecoLacres(formLacres.opcaoId, quantidadePacotes);

    const novoItem: ItemLacre = {
      id: gerarId(),
      opcaoId: formLacres.opcaoId,
      opcaoNome: opcao.nome,
      quantidadePacotes,
      observacoes: formLacres.observacoes,
      quantidadeUnidades: result.unidades,
      precoCartao: result.precoCartao,
      precoPix: result.precoPix,
    };

    setItensLacres([...itensLacres, novoItem]);
    setFormLacres({ ...formLacres, quantidadePacotes: '1', observacoes: '' });
    setSnackbar({ open: true, message: 'Lacre adicionado!', severity: 'success' });
  };

  const removerItem = (tipo: 'adesivo' | 'uv' | 'banner' | 'pacote' | 'milheiro' | 'saborValidade' | 'lacre', id: string) => {
    switch (tipo) {
      case 'adesivo':
        setItensAdesivos(itensAdesivos.filter(item => item.id !== id));
        break;
      case 'uv':
        setItensUV(itensUV.filter(item => item.id !== id));
        break;
      case 'banner':
        setItensBanners(itensBanners.filter(item => item.id !== id));
        break;
      case 'pacote':
        setItensPacotes(itensPacotes.filter(item => item.id !== id));
        break;
      case 'milheiro':
        setItensMilheiro(itensMilheiro.filter(item => item.id !== id));
        break;
      case 'saborValidade':
        setItensSaborValidade(itensSaborValidade.filter(item => item.id !== id));
        break;
      case 'lacre':
        setItensLacres(itensLacres.filter(item => item.id !== id));
        break;
    }
    setSnackbar({ open: true, message: 'Item removido!', severity: 'success' });
  };

  // ==================== FUNÇÕES DE EDIÇÃO ====================

  const editarAdesivo = (id: string) => {
    const item = itensAdesivos.find(i => i.id === id);
    if (item) {
      setFormAdesivo({
        largura: item.largura.toString(),
        altura: item.altura.toString(),
        quantidade: item.quantidade.toString(),
        material: item.material,
        observacoes: item.observacoes,
      });
      setEditingAdesivo(id);
      setActiveTab(0);
    }
  };

  const salvarEdicaoAdesivo = () => {
    if (!editingAdesivo) return;
    
    const largura = parseFloat(formAdesivo.largura);
    const altura = parseFloat(formAdesivo.altura);
    const quantidade = parseInt(formAdesivo.quantidade);

    if (!largura || largura < 3 || largura > 30) {
      setSnackbar({ open: true, message: 'Largura deve estar entre 3 e 30 cm', severity: 'error' });
      return;
    }
    if (!altura || altura < 3 || altura > 30) {
      setSnackbar({ open: true, message: 'Altura deve estar entre 3 e 30 cm', severity: 'error' });
      return;
    }
    if (!quantidade || quantidade < 1 || quantidade > 1000000) {
      setSnackbar({ open: true, message: 'Quantidade deve estar entre 1 e 1.000.000', severity: 'error' });
      return;
    }

    const area = calcularArea(largura, altura, quantidade, PRICES.adesivos.sangria);
    const precos = calcularPrecoAdesivo(area, formAdesivo.material);

    setItensAdesivos(itensAdesivos.map(item => 
      item.id === editingAdesivo
        ? { ...item, largura, altura, quantidade, material: formAdesivo.material, observacoes: formAdesivo.observacoes, area, ...precos }
        : item
    ));
    setFormAdesivo({ largura: '', altura: '', quantidade: '', material: 'Brilho', observacoes: '' });
    setEditingAdesivo(null);
    setSnackbar({ open: true, message: 'Adesivo atualizado!', severity: 'success' });
  };

  const cancelarEdicaoAdesivo = () => {
    setFormAdesivo({ largura: '', altura: '', quantidade: '', material: 'Brilho', observacoes: '' });
    setEditingAdesivo(null);
  };

  const editarUV = (id: string) => {
    const item = itensUV.find(i => i.id === id);
    if (item) {
      setFormUV({
        tamanhoId: item.tamanhoId,
        quantidadePacotes: item.quantidadePacotes.toString(),
        material: item.material,
        observacoes: item.observacoes,
      });
      setEditingUV(id);
      setActiveTab(1);
    }
  };

  const salvarEdicaoUV = () => {
    if (!editingUV) return;
    
    const quantidadePacotes = parseInt(formUV.quantidadePacotes);
    const tamanho = TAMANHOS_UV.find(t => t.id === formUV.tamanhoId);

    if (!quantidadePacotes || quantidadePacotes < 1) {
      setSnackbar({ open: true, message: 'Quantidade deve ser pelo menos 1', severity: 'error' });
      return;
    }

    if (!tamanho) {
      setSnackbar({ open: true, message: 'Selecione um tamanho', severity: 'error' });
      return;
    }

    const precos = calcularPrecoUV(quantidadePacotes);

    setItensUV(itensUV.map(item => 
      item.id === editingUV
        ? { ...item, tamanhoId: formUV.tamanhoId, tamanhoNome: tamanho.nome, quantidadeMinima: tamanho.quantidadeMinima, quantidadePacotes, material: formUV.material, observacoes: formUV.observacoes, ...precos }
        : item
    ));
    setFormUV({ tamanhoId: '3x3', quantidadePacotes: '1', material: 'Brilho UV', observacoes: '' });
    setEditingUV(null);
    setSnackbar({ open: true, message: 'UV atualizado!', severity: 'success' });
  };

  const cancelarEdicaoUV = () => {
    setFormUV({ tamanhoId: '3x3', quantidadePacotes: '1', material: 'Brilho UV', observacoes: '' });
    setEditingUV(null);
  };

  const editarBanner = (id: string) => {
    const item = itensBanners.find(i => i.id === id);
    if (item) {
      setFormBanner({
        largura: item.largura.toString(),
        altura: item.altura.toString(),
        quantidade: item.quantidade.toString(),
        precoM2: item.precoM2.toString(),
        acabamento: item.acabamento,
        observacoes: item.observacoes,
      });
      setEditingBanner(id);
      setActiveTab(2);
    }
  };

  const salvarEdicaoBanner = () => {
    if (!editingBanner) return;
    
    const largura = parseFloat(formBanner.largura.replace(',', '.'));
    const altura = parseFloat(formBanner.altura.replace(',', '.'));
    const quantidade = parseInt(formBanner.quantidade) || 1;
    const precoM2 = parseFloat(formBanner.precoM2) || PRICES.banners.precoM2Promocional;

    if (!largura || largura < 0.10) {
      setSnackbar({ open: true, message: 'Largura mínima: 0,10 m', severity: 'error' });
      return;
    }
    if (!altura || altura < 0.10) {
      setSnackbar({ open: true, message: 'Altura mínima: 0,10 m', severity: 'error' });
      return;
    }

    const result = calcularPrecoBanner(largura, altura, quantidade, precoM2);

    setItensBanners(itensBanners.map(item => 
      item.id === editingBanner
        ? { ...item, largura, altura, quantidade, precoM2, acabamento: formBanner.acabamento, observacoes: formBanner.observacoes, ...result }
        : item
    ));
    setFormBanner({ largura: '0.80', altura: '1.20', quantidade: '1', precoM2: '83.33', acabamento: 'Ilhós', observacoes: '' });
    setEditingBanner(null);
    setSnackbar({ open: true, message: 'Banner atualizado!', severity: 'success' });
  };

  const cancelarEdicaoBanner = () => {
    setFormBanner({ largura: '0.80', altura: '1.20', quantidade: '1', precoM2: '83.33', acabamento: 'Ilhós', observacoes: '' });
    setEditingBanner(null);
  };

  const editarPacote = (id: string) => {
    const item = itensPacotes.find(i => i.id === id);
    if (item) {
      setFormPacote({
        pacoteId: item.pacoteId,
        quantidadePacotes: item.quantidadePacotes.toString(),
        material: item.material,
        observacoes: item.observacoes,
      });
      setEditingPacote(id);
      setActiveTab(3);
    }
  };

  const salvarEdicaoPacote = () => {
    if (!editingPacote) return;
    
    const quantidadePacotes = parseInt(formPacote.quantidadePacotes);

    if (!quantidadePacotes || quantidadePacotes < 1) {
      setSnackbar({ open: true, message: 'Quantidade de pacotes deve ser pelo menos 1', severity: 'error' });
      return;
    }

    const pacote = PACOTES_PRONTOS.find(p => p.id === formPacote.pacoteId);
    if (!pacote) return;

    const result = calcularPrecoPacote(formPacote.pacoteId, quantidadePacotes, formPacote.material);

    setItensPacotes(itensPacotes.map(item => 
      item.id === editingPacote
        ? { ...item, pacoteId: formPacote.pacoteId, pacoteNome: pacote.nome, quantidadePacotes, material: formPacote.material, observacoes: formPacote.observacoes, quantidadeUnidades: result.unidades, precoCartao: result.precoCartao, precoPix: result.precoPix }
        : item
    ));
    setFormPacote({ pacoteId: '3x3', quantidadePacotes: '1', material: 'Brilho', observacoes: '' });
    setEditingPacote(null);
    setSnackbar({ open: true, message: 'Pacote atualizado!', severity: 'success' });
  };

  const cancelarEdicaoPacote = () => {
    setFormPacote({ pacoteId: '3x3', quantidadePacotes: '1', material: 'Brilho', observacoes: '' });
    setEditingPacote(null);
  };

  const editarMilheiro = (id: string) => {
    const item = itensMilheiro.find(i => i.id === id);
    if (item) {
      setFormMilheiro({
        pacoteId: item.pacoteId,
        quantidadePacotes: item.quantidadePacotes.toString(),
        material: item.material,
        observacoes: item.observacoes,
      });
      setEditingMilheiro(id);
      setActiveTab(4);
    }
  };

  const salvarEdicaoMilheiro = () => {
    if (!editingMilheiro) return;
    
    const quantidadePacotes = parseInt(formMilheiro.quantidadePacotes);

    if (!quantidadePacotes || quantidadePacotes < 1) {
      setSnackbar({ open: true, message: 'Quantidade de pacotes deve ser pelo menos 1', severity: 'error' });
      return;
    }

    const pacote = MILHEIRO_PACOTES.find(p => p.id === formMilheiro.pacoteId);
    if (!pacote) return;

    const result = calcularPrecoMilheiro(formMilheiro.pacoteId, quantidadePacotes);

    setItensMilheiro(itensMilheiro.map(item => 
      item.id === editingMilheiro
        ? { ...item, pacoteId: formMilheiro.pacoteId, pacoteNome: pacote.nome, quantidadePacotes, material: formMilheiro.material, observacoes: formMilheiro.observacoes, quantidadeUnidades: result.unidades, precoCartao: result.precoCartao, precoPix: result.precoPix }
        : item
    ));
    setFormMilheiro({ pacoteId: '3x3', quantidadePacotes: '1', material: 'Brilho', observacoes: '' });
    setEditingMilheiro(null);
    setSnackbar({ open: true, message: 'Pacote Milheiro atualizado!', severity: 'success' });
  };

  const cancelarEdicaoMilheiro = () => {
    setFormMilheiro({ pacoteId: '3x3', quantidadePacotes: '1', material: 'Brilho', observacoes: '' });
    setEditingMilheiro(null);
  };

  const editarSaborValidade = (id: string) => {
    const item = itensSaborValidade.find(i => i.id === id);
    if (item) {
      setFormSaborValidade({
        opcaoId: item.opcaoId,
        quantidadePacotes: item.quantidadePacotes.toString(),
        observacoes: item.observacoes,
      });
      setEditingSaborValidade(id);
      setActiveTab(5);
    }
  };

  const salvarEdicaoSaborValidade = () => {
    if (!editingSaborValidade) return;
    const quantidadePacotes = parseInt(formSaborValidade.quantidadePacotes);
    if (!quantidadePacotes || quantidadePacotes < 1) {
      setSnackbar({ open: true, message: 'Quantidade deve ser pelo menos 1', severity: 'error' });
      return;
    }
    const opcao = SABOR_VALIDADE_OPCOES.find(p => p.id === formSaborValidade.opcaoId);
    if (!opcao) return;
    const result = calcularPrecoSaborValidade(formSaborValidade.opcaoId, quantidadePacotes);
    setItensSaborValidade(itensSaborValidade.map(item =>
      item.id === editingSaborValidade
        ? { ...item, opcaoId: formSaborValidade.opcaoId, opcaoNome: opcao.nome, quantidadePacotes, observacoes: formSaborValidade.observacoes, quantidadeUnidades: result.unidades, precoCartao: result.precoCartao, precoPix: result.precoPix, isMilheiro: opcao.isMilheiro }
        : item
    ));
    setFormSaborValidade({ opcaoId: '3x4', quantidadePacotes: '1', observacoes: '' });
    setEditingSaborValidade(null);
    setSnackbar({ open: true, message: 'Sabor e Validade atualizado!', severity: 'success' });
  };

  const cancelarEdicaoSaborValidade = () => {
    setFormSaborValidade({ opcaoId: '3x4', quantidadePacotes: '1', observacoes: '' });
    setEditingSaborValidade(null);
  };

  const editarLacre = (id: string) => {
    const item = itensLacres.find(i => i.id === id);
    if (item) {
      setFormLacres({
        opcaoId: item.opcaoId,
        quantidadePacotes: item.quantidadePacotes.toString(),
        observacoes: item.observacoes,
      });
      setEditingLacres(id);
      setActiveTab(6);
    }
  };

  const salvarEdicaoLacre = () => {
    if (!editingLacres) return;
    const quantidadePacotes = parseInt(formLacres.quantidadePacotes);
    if (!quantidadePacotes || quantidadePacotes < 1) {
      setSnackbar({ open: true, message: 'Quantidade deve ser pelo menos 1', severity: 'error' });
      return;
    }
    const opcao = LACRES_OPCOES.find(p => p.id === formLacres.opcaoId);
    if (!opcao) return;
    const result = calcularPrecoLacres(formLacres.opcaoId, quantidadePacotes);
    setItensLacres(itensLacres.map(item =>
      item.id === editingLacres
        ? { ...item, opcaoId: formLacres.opcaoId, opcaoNome: opcao.nome, quantidadePacotes, observacoes: formLacres.observacoes, quantidadeUnidades: result.unidades, precoCartao: result.precoCartao, precoPix: result.precoPix }
        : item
    ));
    setFormLacres({ opcaoId: '4x9', quantidadePacotes: '1', observacoes: '' });
    setEditingLacres(null);
    setSnackbar({ open: true, message: 'Lacre atualizado!', severity: 'success' });
  };

  const cancelarEdicaoLacre = () => {
    setFormLacres({ opcaoId: '4x9', quantidadePacotes: '1', observacoes: '' });
    setEditingLacres(null);
  };

  const limparTudo = () => {
    setItensAdesivos([]);
    setItensUV([]);
    setItensBanners([]);
    setItensPacotes([]);
    setItensMilheiro([]);
    setItensSaborValidade([]);
    setItensLacres([]);
    setFreteValor('0');
    setFreteOpcao('retirada');
    setObservacoesGerais('');
    // Resetar formulários com valores padrão
    setFormAdesivo({ largura: '', altura: '', quantidade: '', material: 'Brilho', observacoes: '' });
    setFormUV({ tamanhoId: '3x3', quantidadePacotes: '1', material: 'Brilho UV', observacoes: '' });
    setFormBanner({ largura: '0.80', altura: '1.20', quantidade: '1', precoM2: '83.33', acabamento: 'Ilhós', observacoes: '' });
    setFormPacote({ pacoteId: '3x3', quantidadePacotes: '1', material: 'Brilho', observacoes: '' });
    setFormMilheiro({ pacoteId: '3x3', quantidadePacotes: '1', material: 'Brilho', observacoes: '' });
    setFormSaborValidade({ opcaoId: '3x4', quantidadePacotes: '1', observacoes: '' });
    setFormLacres({ opcaoId: '4x9', quantidadePacotes: '1', observacoes: '' });
    // Cancelar edições em andamento
    setEditingAdesivo(null);
    setEditingUV(null);
    setEditingBanner(null);
    setEditingPacote(null);
    setEditingMilheiro(null);
    setEditingSaborValidade(null);
    setEditingLacres(null);
    setSnackbar({ open: true, message: 'Orçamento limpo!', severity: 'success' });
  };

  // ==================== CÁLCULO DE TOTAIS ====================

  const calcularTotais = useCallback(() => {
    let totalPixAdesivos = 0;
    let totalCartaoAdesivos = 0;
    let totalAreaAdesivos = 0;

    let totalPixUV = 0;
    let totalCartaoUV = 0;
    let totalUnidadesUV = 0;

    let totalPixBanners = 0;
    let totalCartaoBanners = 0;
    let totalAreaBanners = 0;

    let totalPixPacotes = 0;
    let totalCartaoPacotes = 0;
    let totalUnidadesPacotes = 0;

    let totalPixMilheiro = 0;
    let totalCartaoMilheiro = 0;
    let totalUnidadesMilheiro = 0;

    let totalPixSaborValidade = 0;
    let totalCartaoSaborValidade = 0;
    let totalUnidadesSaborValidade = 0;

    let totalPixLacres = 0;
    let totalCartaoLacres = 0;
    let totalUnidadesLacres = 0;

    itensAdesivos.forEach(item => {
      totalPixAdesivos += item.precoPix;
      totalCartaoAdesivos += item.precoCartao;
      totalAreaAdesivos += item.area;
    });

    itensUV.forEach(item => {
      totalPixUV += item.precoPix;
      totalCartaoUV += item.precoCartao;
      totalUnidadesUV += item.quantidadeMinima * item.quantidadePacotes;
    });

    itensBanners.forEach(item => {
      totalPixBanners += item.precoPix;
      totalCartaoBanners += item.precoCartao;
      totalAreaBanners += item.area;
    });

    itensPacotes.forEach(item => {
      totalPixPacotes += item.precoPix;
      totalCartaoPacotes += item.precoCartao;
      totalUnidadesPacotes += item.quantidadeUnidades;
    });

    itensMilheiro.forEach(item => {
      totalPixMilheiro += item.precoPix;
      totalCartaoMilheiro += item.precoCartao;
      totalUnidadesMilheiro += item.quantidadeUnidades;
    });

    itensSaborValidade.forEach(item => {
      totalPixSaborValidade += item.precoPix;
      totalCartaoSaborValidade += item.precoCartao;
      totalUnidadesSaborValidade += item.quantidadeUnidades;
    });

    itensLacres.forEach(item => {
      totalPixLacres += item.precoPix;
      totalCartaoLacres += item.precoCartao;
      totalUnidadesLacres += item.quantidadeUnidades;
    });

    const frete = parseFloat(freteValor) || 0;

    const totalPix = totalPixAdesivos + totalPixUV + totalPixBanners + totalPixPacotes + totalPixMilheiro + totalPixSaborValidade + totalPixLacres + frete;
    const totalCartao = totalCartaoAdesivos + totalCartaoUV + totalCartaoBanners + totalCartaoPacotes + totalCartaoMilheiro + totalCartaoSaborValidade + totalCartaoLacres + frete;
    const totalArea = totalAreaAdesivos + totalAreaBanners;

    return {
      totalPix: Number(totalPix.toFixed(2)),
      totalCartao: Number(totalCartao.toFixed(2)),
      totalArea: Number(totalArea.toFixed(4)),
      totalUnidadesPacotes,
      totalUnidadesMilheiro,
      totalUnidadesSaborValidade,
      totalUnidadesLacres,
      totalUnidadesUV,
      frete,
      adesivos: { pix: totalPixAdesivos.toFixed(2), cartao: totalCartaoAdesivos.toFixed(2), area: totalAreaAdesivos.toFixed(4) },
      uv: { pix: totalPixUV.toFixed(2), cartao: totalCartaoUV.toFixed(2), unidades: totalUnidadesUV },
      banners: { pix: totalPixBanners.toFixed(2), cartao: totalCartaoBanners.toFixed(2), area: totalAreaBanners.toFixed(4) },
      pacotes: { pix: totalPixPacotes.toFixed(2), cartao: totalCartaoPacotes.toFixed(2), unidades: totalUnidadesPacotes },
      milheiro: { pix: totalPixMilheiro.toFixed(2), cartao: totalCartaoMilheiro.toFixed(2), unidades: totalUnidadesMilheiro },
      saborValidade: { pix: totalPixSaborValidade.toFixed(2), cartao: totalCartaoSaborValidade.toFixed(2), unidades: totalUnidadesSaborValidade },
      lacres: { pix: totalPixLacres.toFixed(2), cartao: totalCartaoLacres.toFixed(2), unidades: totalUnidadesLacres },
    };
  }, [itensAdesivos, itensUV, itensBanners, itensPacotes, itensMilheiro, itensSaborValidade, itensLacres, freteValor]);

  const totais = calcularTotais();

  // ==================== GERAÇÃO DE ORÇAMENTO ====================

  const gerarOrcamento = () => {
    let texto: string;
    const totalMaterialPix = parseFloat(totais.adesivos.pix) + parseFloat(totais.uv.pix) + parseFloat(totais.banners.pix) + parseFloat(totais.pacotes.pix) + parseFloat(totais.milheiro.pix) + parseFloat(totais.saborValidade.pix) + parseFloat(totais.lacres.pix);
    const totalMaterialCartao = parseFloat(totais.adesivos.cartao) + parseFloat(totais.uv.cartao) + parseFloat(totais.banners.cartao) + parseFloat(totais.pacotes.cartao) + parseFloat(totais.milheiro.cartao) + parseFloat(totais.saborValidade.cartao) + parseFloat(totais.lacres.cartao);

    if (tipoOrcamento === 'Básico') {
      texto = `Rótulos Adesivos em Vinil à Prova d'Agua\n\n`;

      // Adesivos
      if (itensAdesivos.length > 0) {
        itensAdesivos.forEach((item) => {
          texto += `Adesivo - ${item.largura} x ${item.altura} cm, Qtd: ${item.quantidade.toLocaleString('pt-BR')}, ${item.material} - R$ ${item.precoPix.toFixed(2)}\n`;
        });
      }
      // UV
      if (itensUV.length > 0) {
        itensUV.forEach((item) => {
          const unidadesTotal = item.quantidadeMinima * item.quantidadePacotes;
          texto += `Adesivo UV - ${item.tamanhoNome}, Qtd: ${unidadesTotal.toLocaleString('pt-BR')}, ${item.material} - R$ ${item.precoPix.toFixed(2)}\n`;
        });
      }
      // Banners
      if (itensBanners.length > 0) {
        itensBanners.forEach((item) => {
          texto += `Banner - ${item.largura.toFixed(2)}m x ${item.altura.toFixed(2)}m, Qtd: ${item.quantidade}, ${item.acabamento} - R$ ${item.precoPix.toFixed(2)}\n`;
        });
      }
      // Pacotes
      if (itensPacotes.length > 0) {
        itensPacotes.forEach((item) => {
          texto += `Pacote ${item.pacoteNome} - Qtd: ${item.quantidadeUnidades.toLocaleString('pt-BR')}, ${item.material} - R$ ${item.precoPix.toFixed(2)}\n`;
        });
      }
      // Milheiro
      if (itensMilheiro.length > 0) {
        itensMilheiro.forEach((item) => {
          texto += `Milheiro ${item.pacoteNome} - Qtd: ${item.quantidadeUnidades.toLocaleString('pt-BR')}, ${item.material} - R$ ${item.precoPix.toFixed(2)}\n`;
        });
      }
      // Sabor e Validade
      if (itensSaborValidade.length > 0) {
        itensSaborValidade.forEach((item) => {
          texto += `Adesivo Sabor e Validade - ${item.opcaoNome}, Qtd: ${item.quantidadeUnidades.toLocaleString('pt-BR')} - R$ ${item.precoPix.toFixed(2)}\n`;
        });
      }
      // Lacres
      if (itensLacres.length > 0) {
        itensLacres.forEach((item) => {
          texto += `Lacre ${item.opcaoNome}, Qtd: ${item.quantidadeUnidades.toLocaleString('pt-BR')} un - R$ ${item.precoPix.toFixed(2)}\n`;
        });
      }
      if (itensAdesivos.length === 0 && itensUV.length === 0 && itensBanners.length === 0 && itensPacotes.length === 0 && itensMilheiro.length === 0 && itensSaborValidade.length === 0 && itensLacres.length === 0) {
        texto += `Adesivo - 0 x 0 cm, Qtd: 0, Brilho - R$ 0\n`;
      }

      texto += `\n💰 Total do MATERIAL no PIX: R$ ${totalMaterialPix.toFixed(2)}\n`;
      texto += `💳 Total do MATERIAL no Cartão: R$ ${totalMaterialCartao.toFixed(2)} em até 6x sem juros.\n\n`;
      texto += `✈️ Frete calculado à parte\n`;
      texto += `OBS: Me informa o seu CEP que eu faço a cotação do frete pra você`;
    } else {
      texto = `📋 Tipo de pedido: ${tipoOrcamento}\n\n`;
      texto += `✅ Itens do pedido:\n\n`;

      // Adesivos Personalizados
      if (itensAdesivos.length > 0) {
        itensAdesivos.forEach((item) => {
          texto += `Adesivo Personalizado - ${item.largura} x ${item.altura} cm, ${item.material}, Qtd: ${item.quantidade.toLocaleString('pt-BR')} - R$ ${item.precoPix.toFixed(2)}\n`;
          if (item.observacoes) texto += `Obs: ${item.observacoes}\n`;
        });
        texto += `\n`;
      }

      // UV
      if (itensUV.length > 0) {
        itensUV.forEach((item) => {
          const unidadesTotal = item.quantidadeMinima * item.quantidadePacotes;
          texto += `Adesivo UV - ${item.tamanhoNome}, ${item.material}, Qtd: ${unidadesTotal.toLocaleString('pt-BR')} - R$ ${item.precoPix.toFixed(2)}\n`;
          if (item.observacoes) texto += `Obs: ${item.observacoes}\n`;
        });
        texto += `\n`;
      }

      // Banners
      if (itensBanners.length > 0) {
        itensBanners.forEach((item) => {
          texto += `Banner - ${item.largura.toFixed(2)}m x ${item.altura.toFixed(2)}m, ${item.acabamento}, Qtd: ${item.quantidade} - R$ ${item.precoPix.toFixed(2)}\n`;
          if (item.observacoes) texto += `Obs: ${item.observacoes}\n`;
        });
        texto += `\n`;
      }

      // Pacotes
      if (itensPacotes.length > 0) {
        itensPacotes.forEach((item) => {
          texto += `Pacote ${item.pacoteNome} - ${item.material}, Qtd: ${item.quantidadeUnidades.toLocaleString('pt-BR')} un - R$ ${item.precoPix.toFixed(2)}\n`;
          if (item.observacoes) texto += `Obs: ${item.observacoes}\n`;
        });
        texto += `\n`;
      }

      // Milheiro
      if (itensMilheiro.length > 0) {
        itensMilheiro.forEach((item) => {
          texto += `Milheiro ${item.pacoteNome} - ${item.material}, Qtd: ${item.quantidadeUnidades.toLocaleString('pt-BR')} un - R$ ${item.precoPix.toFixed(2)}\n`;
          if (item.observacoes) texto += `Obs: ${item.observacoes}\n`;
        });
        texto += `\n`;
      }

      // Sabor e Validade
      if (itensSaborValidade.length > 0) {
        itensSaborValidade.forEach((item) => {
          texto += `Adesivo Sabor e Validade - ${item.opcaoNome}, Qtd: ${item.quantidadeUnidades.toLocaleString('pt-BR')} un - R$ ${item.precoPix.toFixed(2)}\n`;
          if (item.observacoes) texto += `Obs: ${item.observacoes}\n`;
        });
        texto += `\n`;
      }

      // Lacres
      if (itensLacres.length > 0) {
        itensLacres.forEach((item) => {
          texto += `Lacre ${item.opcaoNome}, Qtd: ${item.quantidadeUnidades.toLocaleString('pt-BR')} un - R$ ${item.precoPix.toFixed(2)}\n`;
          if (item.observacoes) texto += `Obs: ${item.observacoes}\n`;
        });
        texto += `\n`;
      }

      // Frete
      const freteNome = OPCOES_FRETE.find(f => f.id === freteOpcao)?.nome || 'Personalizado';
      texto += `🚚 Opções de envio:\n`;
      texto += `${freteNome}${totais.frete > 0 ? ` - R$ ${totais.frete.toFixed(2)}` : ''}\n\n`;

      // Totais
      texto += `💰 Total: R$ ${totais.totalPix.toFixed(2)} no PIX\n`;
      texto += `💳 Ou no cartão: R$ ${totais.totalCartao.toFixed(2)} em até 6x sem juros.\n\n`;

      // Observações
      if (observacoesGerais) {
        texto += `📝 ${observacoesGerais}\n\n`;
      }

      texto += `👉 Pronto para aprovar ou tem ajustes? Estamos à disposição!`;
    }

    setOrcamentoTexto(texto);
    setOpenOrcamentoDialog(true);
  };

  const copiarOrcamento = () => {
    navigator.clipboard.writeText(orcamentoTexto);
    setSnackbar({ open: true, message: 'Orçamento copiado para a área de transferência!', severity: 'success' });
    setOpenOrcamentoDialog(false);
  };

  // ==================== FUNÇÕES DE CACHE E TAMANHOS ====================

  const salvarOrcamentoCache = () => {
    if (!nomeOrcamento.trim()) {
      setSnackbar({ open: true, message: 'Digite um nome para o orçamento', severity: 'error' });
      return;
    }

    const novoOrcamento: OrcamentoSalvo = {
      id: Date.now().toString(),
      nome: nomeOrcamento.trim(),
      dataSalvo: new Date().toLocaleString('pt-BR'),
      itensAdesivos,
      itensUV,
      itensBanners,
      itensPacotes,
      itensMilheiro,
      itensSaborValidade,
      itensLacres,
      freteOpcao,
      freteValor,
      tipoOrcamento,
      observacoesGerais,
    };

    const novosOrcamentos = [novoOrcamento, ...orcamentosSalvos].slice(0, 10); // Manter apenas 10 últimos
    setOrcamentosSalvos(novosOrcamentos);
    localStorage.setItem('vettorprint_orcamentos', JSON.stringify(novosOrcamentos));
    setNomeOrcamento('');
    setDialogSalvar(false);
    setSnackbar({ open: true, message: 'Orçamento salvo!', severity: 'success' });
  };

  const carregarOrcamento = (orcamento: OrcamentoSalvo) => {
    setItensAdesivos(orcamento.itensAdesivos || []);
    setItensUV(orcamento.itensUV || []);
    // Garantir compatibilidade com banners antigos que não têm precoM2
    const bannersComPrecoM2 = (orcamento.itensBanners || []).map(banner => ({
      ...banner,
      precoM2: (banner as any).precoM2 || PRICES.banners.precoM2Promocional
    }));
    setItensBanners(bannersComPrecoM2);
    setItensPacotes(orcamento.itensPacotes || []);
    setItensMilheiro(orcamento.itensMilheiro || []);
    setItensSaborValidade(orcamento.itensSaborValidade || []);
    setItensLacres(orcamento.itensLacres || []);
    setFreteOpcao(orcamento.freteOpcao || 'retirada');
    setFreteValor(orcamento.freteValor || '0');
    setTipoOrcamento(orcamento.tipoOrcamento || 'Novo Pedido');
    setObservacoesGerais(orcamento.observacoesGerais || '');
    setDialogHistorico(false);
    setSnackbar({ open: true, message: `Orçamento "${orcamento.nome}" carregado!`, severity: 'success' });
  };

  const excluirOrcamentoCache = (id: string) => {
    const novosOrcamentos = orcamentosSalvos.filter(o => o.id !== id);
    setOrcamentosSalvos(novosOrcamentos);
    localStorage.setItem('vettorprint_orcamentos', JSON.stringify(novosOrcamentos));
    setSnackbar({ open: true, message: 'Orçamento excluído!', severity: 'success' });
  };

  const adicionarTamanhoPersonalizado = () => {
    const largura = parseFloat(novoTamanho.largura);
    const altura = parseFloat(novoTamanho.altura);
    const quantidade = parseInt(novoTamanho.quantidade);

    if (!novoTamanho.nome.trim()) {
      setSnackbar({ open: true, message: 'Digite um nome para o tamanho', severity: 'error' });
      return;
    }
    if (!largura || largura <= 0) {
      setSnackbar({ open: true, message: 'Largura inválida', severity: 'error' });
      return;
    }
    if (!altura || altura <= 0) {
      setSnackbar({ open: true, message: 'Altura inválida', severity: 'error' });
      return;
    }
    if (!quantidade || quantidade <= 0) {
      setSnackbar({ open: true, message: 'Quantidade inválida', severity: 'error' });
      return;
    }

    const novo: TamanhoPersonalizado = {
      id: editingTamanho || Date.now().toString(),
      nome: novoTamanho.nome.trim(),
      largura,
      altura,
      quantidade,
    };

    let novosTamanhos: TamanhoPersonalizado[];
    if (editingTamanho) {
      novosTamanhos = tamanhosPersonalizados.map(t => t.id === editingTamanho ? novo : t);
      setEditingTamanho(null);
    } else {
      novosTamanhos = [...tamanhosPersonalizados, novo];
    }

    setTamanhosPersonalizados(novosTamanhos);
    localStorage.setItem('vettorprint_tamanhos', JSON.stringify(novosTamanhos));
    setNovoTamanho({ nome: '', largura: '', altura: '', quantidade: '' });
    setSnackbar({ open: true, message: editingTamanho ? 'Tamanho atualizado!' : 'Tamanho adicionado!', severity: 'success' });
  };

  const editarTamanhoPersonalizado = (tamanho: TamanhoPersonalizado) => {
    setNovoTamanho({
      nome: tamanho.nome,
      largura: tamanho.largura.toString(),
      altura: tamanho.altura.toString(),
      quantidade: tamanho.quantidade.toString(),
    });
    setEditingTamanho(tamanho.id);
  };

  const excluirTamanhoPersonalizado = (id: string) => {
    const novosTamanhos = tamanhosPersonalizados.filter(t => t.id !== id);
    setTamanhosPersonalizados(novosTamanhos);
    localStorage.setItem('vettorprint_tamanhos', JSON.stringify(novosTamanhos));
    setSnackbar({ open: true, message: 'Tamanho excluído!', severity: 'success' });
  };

  const usarTamanhoPersonalizado = (tamanho: TamanhoPersonalizado) => {
    setFormAdesivo({
      ...formAdesivo,
      largura: tamanho.largura.toString(),
      altura: tamanho.altura.toString(),
      quantidade: tamanho.quantidade.toString(),
    });
    setActiveTab(0); // Ir para aba de adesivos
    setDialogTamanhos(false);
    setSnackbar({ open: true, message: `Tamanho "${tamanho.nome}" aplicado!`, severity: 'success' });
  };

  // ==================== RENDERIZAÇÃO ====================

  const formatCurrency = (value: number) => `R$ ${value.toFixed(2).replace('.', ',')}`;

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a1a1a', display: 'flex', alignItems: 'center', gap: 1 }}>
            <CalculateIcon sx={{ color: '#D4AF37' }} />
            Orçamento Rápido
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Calcule orçamentos para adesivos, banners e pacotes
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<RefreshIcon />}
            onClick={limparTudo}
            color="error"
          >
            Limpar
          </Button>
          <Button
            variant="contained"
            size="small"
            startIcon={<CopyIcon />}
            onClick={gerarOrcamento}
            disabled={itensAdesivos.length === 0 && itensUV.length === 0 && itensBanners.length === 0 && itensPacotes.length === 0 && itensMilheiro.length === 0 && itensSaborValidade.length === 0 && itensLacres.length === 0}
            sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}
          >
            Gerar Orçamento
          </Button>
        </Box>
      </Box>

      <Grid container spacing={2}>
        {/* Coluna Principal - Formulários */}
        <Grid item xs={12} lg={8}>
          <Card elevation={0} sx={{ border: '1px solid #e5e7eb' }}>
            <Tabs
              value={activeTab}
              onChange={(_, newValue) => setActiveTab(newValue)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                borderBottom: '1px solid #e5e7eb',
                '& .MuiTab-root': { fontWeight: 600, textTransform: 'none', minHeight: 48 },
                '& .Mui-selected': { color: '#D4AF37' },
                '& .MuiTabs-indicator': { backgroundColor: '#D4AF37' },
              }}
            >
              <Tab label={`Adesivos (${itensAdesivos.length})`} />
              <Tab label={`UV (${itensUV.length})`} />
              <Tab label={`Banners (${itensBanners.length})`} />
              <Tab label={`Pacotes (${itensPacotes.length})`} />
              <Tab label={`Milheiro (${itensMilheiro.length})`} />
              <Tab label={`Sabor e Validade (${itensSaborValidade.length})`} />
              <Tab label={`Lacres (${itensLacres.length})`} />
            </Tabs>

            {/* Aba Adesivos */}
            <TabPanel value={activeTab} index={0}>
              <CardContent sx={{ pt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Largura (cm)"
                      type="number"
                      value={formAdesivo.largura}
                      onChange={(e) => setFormAdesivo({ ...formAdesivo, largura: e.target.value })}
                      inputProps={{ min: 3, max: 30, step: 0.1 }}
                    />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Altura (cm)"
                      type="number"
                      value={formAdesivo.altura}
                      onChange={(e) => setFormAdesivo({ ...formAdesivo, altura: e.target.value })}
                      inputProps={{ min: 3, max: 30, step: 0.1 }}
                    />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Quantidade"
                      type="number"
                      value={formAdesivo.quantidade}
                      onChange={(e) => setFormAdesivo({ ...formAdesivo, quantidade: e.target.value })}
                      inputProps={{ min: 1, max: 1000000 }}
                    />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Material</InputLabel>
                      <Select
                        value={formAdesivo.material}
                        onChange={(e) => setFormAdesivo({ ...formAdesivo, material: e.target.value })}
                        label="Material"
                      >
                        {MATERIAIS_ADESIVOS.map(mat => (
                          <MenuItem key={mat} value={mat}>{mat}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Observações"
                      value={formAdesivo.observacoes}
                      onChange={(e) => setFormAdesivo({ ...formAdesivo, observacoes: e.target.value })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    {editingAdesivo ? (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button fullWidth size="small" variant="contained" color="success" onClick={salvarEdicaoAdesivo}>
                          Salvar
                        </Button>
                        <Button size="small" variant="outlined" color="error" onClick={cancelarEdicaoAdesivo}>
                          Cancelar
                        </Button>
                      </Box>
                    ) : (
                      <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={adicionarAdesivo}
                        sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}
                      >
                        Adicionar
                      </Button>
                    )}
                  </Grid>
                </Grid>

                {/* Aviso de edição */}
                {editingAdesivo && (
                  <Alert severity="info" sx={{ mt: 2 }}>
                    Editando item... Faça as alterações e clique em "Salvar" ou "Cancelar"
                  </Alert>
                )}

                {/* Preview */}
                {previewAdesivo.area > 0 && (
                  <Paper variant="outlined" sx={{ mt: 2, p: 1.5, backgroundColor: '#f8fafc' }}>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                      <Typography variant="body2" color="text.secondary">Área: <strong>{previewAdesivo.area.toFixed(4)} m²</strong></Typography>
                      <Chip size="small" label={`PIX: ${formatCurrency(previewAdesivo.precoPix)}`} color="success" />
                      <Chip size="small" label={`Cartão: ${formatCurrency(previewAdesivo.precoCartao)}`} color="primary" />
                    </Box>
                  </Paper>
                )}

                {/* Lista de Itens */}
                {itensAdesivos.length > 0 && (
                  <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
                    <Table size="small">
                      <TableHead sx={{ backgroundColor: '#f8fafc' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Dimensões</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Qtd</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Material</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Área</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>PIX</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Cartão</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Ações</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {itensAdesivos.map((item) => (
                          <TableRow key={item.id} hover>
                            <TableCell>{item.largura}x{item.altura}cm</TableCell>
                            <TableCell>{item.quantidade.toLocaleString('pt-BR')}</TableCell>
                            <TableCell><Chip label={item.material} size="small" color={item.material === 'Transparente' ? 'secondary' : 'primary'} /></TableCell>
                            <TableCell>{item.area.toFixed(4)} m²</TableCell>
                            <TableCell sx={{ color: '#10b981', fontWeight: 600 }}>{formatCurrency(item.precoPix)}</TableCell>
                            <TableCell sx={{ color: '#3b82f6', fontWeight: 600 }}>{formatCurrency(item.precoCartao)}</TableCell>
                            <TableCell>
                              <Tooltip title="Editar">
                                <IconButton size="small" onClick={() => editarAdesivo(item.id)} color="primary">
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Remover">
                                <IconButton size="small" onClick={() => removerItem('adesivo', item.id)} color="error">
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </TabPanel>

            {/* Aba UV */}
            <TabPanel value={activeTab} index={1}>
              <CardContent sx={{ pt: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 2, color: 'text.secondary' }}>
                  Preço fixo: <strong style={{ color: '#10b981' }}>PIX R$ 39,99</strong> | <strong style={{ color: '#3b82f6' }}>Cartão R$ 44,43</strong> por pacote
                </Typography>
                
                <Grid container spacing={2}>
                  {/* Seleção de Tamanho com Radio */}
                  <Grid item xs={12} sm={5}>
                    <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>Tamanho e Quantidade</Typography>
                    <Paper variant="outlined" sx={{ p: 1.5 }}>
                      {TAMANHOS_UV.map((tamanho) => (
                        <Box key={tamanho.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                          <FormControlLabel
                            control={
                              <input
                                type="radio"
                                name="tamanhoUV"
                                checked={formUV.tamanhoId === tamanho.id}
                                onChange={() => setFormUV({ ...formUV, tamanhoId: tamanho.id })}
                                style={{ marginRight: 8 }}
                              />
                            }
                            label={<Typography variant="body2">{tamanho.nome} - {tamanho.quantidadeMinima} unidades</Typography>}
                          />
                          <TextField
                            size="small"
                            type="number"
                            value={formUV.tamanhoId === tamanho.id ? formUV.quantidadePacotes : '0'}
                            onChange={(e) => setFormUV({ ...formUV, tamanhoId: tamanho.id, quantidadePacotes: e.target.value })}
                            inputProps={{ min: 0, style: { width: 50, textAlign: 'center' } }}
                            sx={{ width: 70 }}
                          />
                        </Box>
                      ))}
                    </Paper>
                  </Grid>

                  {/* Material e Observações */}
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel>Material</InputLabel>
                      <Select value={formUV.material} onChange={(e) => setFormUV({ ...formUV, material: e.target.value })} label="Material">
                        {MATERIAIS_UV.map(mat => (<MenuItem key={mat} value={mat}>{mat}</MenuItem>))}
                      </Select>
                    </FormControl>
                    <TextField fullWidth size="small" label="Observações" value={formUV.observacoes}
                      onChange={(e) => setFormUV({ ...formUV, observacoes: e.target.value })} multiline rows={3} />
                  </Grid>

                  {/* Botões */}
                  <Grid item xs={12} sm={3}>
                    {editingUV ? (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Button fullWidth size="small" variant="contained" color="success" onClick={salvarEdicaoUV}>Salvar</Button>
                        <Button fullWidth size="small" variant="outlined" color="error" onClick={cancelarEdicaoUV}>Cancelar</Button>
                      </Box>
                    ) : (
                      <Button fullWidth size="small" variant="contained" startIcon={<AddIcon />} onClick={adicionarUV}
                        sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}>
                        Adicionar
                      </Button>
                    )}
                  </Grid>
                </Grid>

                {editingUV && (<Alert severity="info" sx={{ mt: 2 }}>Editando item UV...</Alert>)}

                {previewUV.unidades > 0 && (
                  <Paper variant="outlined" sx={{ mt: 2, p: 1.5, backgroundColor: '#f8fafc' }}>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                      <Typography variant="body2" color="text.secondary">Total: <strong>{previewUV.unidades.toLocaleString('pt-BR')} unidades</strong></Typography>
                      <Chip size="small" label={`PIX: ${formatCurrency(previewUV.precoPix)}`} color="success" />
                      <Chip size="small" label={`Cartão: ${formatCurrency(previewUV.precoCartao)}`} color="primary" />
                    </Box>
                  </Paper>
                )}

                {itensUV.length > 0 && (
                  <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
                    <Table size="small">
                      <TableHead sx={{ backgroundColor: '#f8fafc' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Tamanho</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Pacotes</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Unidades</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Material</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>PIX</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Cartão</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Ações</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {itensUV.map((item) => (
                          <TableRow key={item.id} hover>
                            <TableCell>{item.tamanhoNome}</TableCell>
                            <TableCell>{item.quantidadePacotes}</TableCell>
                            <TableCell>{(item.quantidadeMinima * item.quantidadePacotes).toLocaleString('pt-BR')}</TableCell>
                            <TableCell><Chip label={item.material} size="small" color="secondary" /></TableCell>
                            <TableCell sx={{ color: '#10b981', fontWeight: 600 }}>{formatCurrency(item.precoPix)}</TableCell>
                            <TableCell sx={{ color: '#3b82f6', fontWeight: 600 }}>{formatCurrency(item.precoCartao)}</TableCell>
                            <TableCell>
                              <Tooltip title="Editar"><IconButton size="small" onClick={() => editarUV(item.id)} color="primary"><EditIcon fontSize="small" /></IconButton></Tooltip>
                              <Tooltip title="Remover"><IconButton size="small" onClick={() => removerItem('uv', item.id)} color="error"><DeleteIcon fontSize="small" /></IconButton></Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </TabPanel>

            {/* Aba Banners */}
            <TabPanel value={activeTab} index={2}>
              <CardContent sx={{ pt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={2}>
                    <TextField fullWidth size="small" label="Largura (m)" value={formBanner.largura}
                      onChange={(e) => setFormBanner({ ...formBanner, largura: e.target.value })} 
                      placeholder="0.80"
                      helperText="Ex: 0.80" />
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <TextField fullWidth size="small" label="Altura (m)" value={formBanner.altura}
                      onChange={(e) => setFormBanner({ ...formBanner, altura: e.target.value })} 
                      placeholder="1.20"
                      helperText="Ex: 1.20" />
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <TextField fullWidth size="small" label="Quantidade" type="number" value={formBanner.quantidade}
                      onChange={(e) => setFormBanner({ ...formBanner, quantidade: e.target.value })} inputProps={{ min: 1 }} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Preço por m²</InputLabel>
                      <Select value={formBanner.precoM2} onChange={(e) => {
                        const val = e.target.value;
                        if (val === '124.975' || val === '99.975') {
                          setFormBanner({ ...formBanner, precoM2: val, largura: '0.50', altura: '0.80' });
                        } else if (val === '83.33' || val === '62.4896') {
                          setFormBanner({ ...formBanner, precoM2: val, largura: '0.80', altura: '1.20' });
                        } else {
                          setFormBanner({ ...formBanner, precoM2: val });
                        }
                      }} label="Preço por m²">
                        <MenuItem value="124.975">R$ 49,99 PIX / R$ 55,54 Cartão (0,50x0,80m)</MenuItem>
                        <MenuItem value="99.975">🔥 PROMOÇÃO — R$ 39,99 PIX / R$ 44,43 Cartão (0,50x0,80m)</MenuItem>
                        <MenuItem value="83.33">R$ 80 PIX / R$ 88,88 Cartão (0,80x1,20m)</MenuItem>
                        <MenuItem value="62.4896">🔥 PROMOÇÃO — R$ 59,99 PIX / R$ 66,65 Cartão (0,80x1,20m)</MenuItem>
                        <MenuItem value="90.00">R$ 90,00/m² (Padrão)</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Acabamento</InputLabel>
                      <Select value={formBanner.acabamento} onChange={(e) => setFormBanner({ ...formBanner, acabamento: e.target.value })} label="Acabamento">
                        {ACABAMENTOS_BANNER.map(acab => (<MenuItem key={acab} value={acab}>{acab}</MenuItem>))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    {editingBanner ? (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button fullWidth size="small" variant="contained" color="success" onClick={salvarEdicaoBanner}>Salvar</Button>
                        <Button size="small" variant="outlined" color="error" onClick={cancelarEdicaoBanner}>Cancelar</Button>
                      </Box>
                    ) : (
                      <Button fullWidth size="small" variant="contained" startIcon={<AddIcon />} onClick={adicionarBanner}
                        sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}>
                        Adicionar
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <TextField fullWidth size="small" label="Observações" value={formBanner.observacoes}
                      onChange={(e) => setFormBanner({ ...formBanner, observacoes: e.target.value })} />
                  </Grid>
                </Grid>

                {editingBanner && (<Alert severity="info" sx={{ mt: 2 }}>Editando banner...</Alert>)}

                {previewBanner.area > 0 && (
                  <Paper variant="outlined" sx={{ mt: 2, p: 1.5, backgroundColor: '#f8fafc' }}>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                      <Typography variant="body2" color="text.secondary">Área: <strong>{previewBanner.area.toFixed(2)} m²</strong></Typography>
                      <Chip size="small" label={`PIX: ${formatCurrency(previewBanner.precoPix)}`} color="success" />
                      <Chip size="small" label={`Cartão: ${formatCurrency(previewBanner.precoCartao)}`} color="primary" />
                    </Box>
                  </Paper>
                )}

                {itensBanners.length > 0 && (
                  <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
                    <Table size="small">
                      <TableHead sx={{ backgroundColor: '#f8fafc' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Dimensões</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Qtd</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Acabamento</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Área</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>PIX</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Cartão</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Ações</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {itensBanners.map((item) => (
                          <TableRow key={item.id} hover>
                            <TableCell>{item.largura.toFixed(2)}m × {item.altura.toFixed(2)}m</TableCell>
                            <TableCell>{item.quantidade}</TableCell>
                            <TableCell>{item.acabamento}</TableCell>
                            <TableCell>{item.area.toFixed(2)} m²</TableCell>
                            <TableCell sx={{ color: '#10b981', fontWeight: 600 }}>{formatCurrency(item.precoPix)}</TableCell>
                            <TableCell sx={{ color: '#3b82f6', fontWeight: 600 }}>{formatCurrency(item.precoCartao)}</TableCell>
                            <TableCell>
                              <Tooltip title="Editar"><IconButton size="small" onClick={() => editarBanner(item.id)} color="primary"><EditIcon fontSize="small" /></IconButton></Tooltip>
                              <Tooltip title="Remover"><IconButton size="small" onClick={() => removerItem('banner', item.id)} color="error"><DeleteIcon fontSize="small" /></IconButton></Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </TabPanel>

            {/* Aba Pacotes */}
            <TabPanel value={activeTab} index={3}>
              <CardContent sx={{ pt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Pacote</InputLabel>
                      <Select value={formPacote.pacoteId} onChange={(e) => setFormPacote({ ...formPacote, pacoteId: e.target.value })} label="Pacote">
                        {PACOTES_PRONTOS.map(pac => (<MenuItem key={pac.id} value={pac.id}>{pac.nome} ({pac.quantidade}un)</MenuItem>))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <TextField fullWidth size="small" label="Qtd Pacotes" type="number" value={formPacote.quantidadePacotes}
                      onChange={(e) => setFormPacote({ ...formPacote, quantidadePacotes: e.target.value })} inputProps={{ min: 1 }} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Material</InputLabel>
                      <Select value={formPacote.material} onChange={(e) => setFormPacote({ ...formPacote, material: e.target.value })} label="Material">
                        <MenuItem value="Brilho">Brilho</MenuItem>
                        <MenuItem value="Fosco">Fosco</MenuItem>
                        <MenuItem value="Transparente">Transparente</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    {editingPacote ? (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button fullWidth size="small" variant="contained" color="success" onClick={salvarEdicaoPacote}>Salvar</Button>
                        <Button size="small" variant="outlined" color="error" onClick={cancelarEdicaoPacote}>Cancelar</Button>
                      </Box>
                    ) : (
                      <Button fullWidth size="small" variant="contained" startIcon={<AddIcon />} onClick={adicionarPacote}
                        sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}>
                        Adicionar
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <TextField fullWidth size="small" label="Observações" value={formPacote.observacoes}
                      onChange={(e) => setFormPacote({ ...formPacote, observacoes: e.target.value })} />
                  </Grid>
                </Grid>

                {editingPacote && (<Alert severity="info" sx={{ mt: 2 }}>Editando pacote...</Alert>)}

                {previewPacote.unidades > 0 && (
                  <Paper variant="outlined" sx={{ mt: 2, p: 1.5, backgroundColor: '#f8fafc' }}>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                      <Typography variant="body2" color="text.secondary">Total: <strong>{previewPacote.unidades} unidades</strong></Typography>
                      <Chip size="small" label={`PIX: ${formatCurrency(previewPacote.precoPix)}`} color="success" />
                      <Chip size="small" label={`Cartão: ${formatCurrency(previewPacote.precoCartao)}`} color="primary" />
                    </Box>
                  </Paper>
                )}

                {itensPacotes.length > 0 && (
                  <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
                    <Table size="small">
                      <TableHead sx={{ backgroundColor: '#f8fafc' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Pacote</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Qtd</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Material</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Unidades</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>PIX</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Cartão</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Ações</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {itensPacotes.map((item) => (
                          <TableRow key={item.id} hover>
                            <TableCell>{item.pacoteNome}</TableCell>
                            <TableCell>{item.quantidadePacotes}</TableCell>
                            <TableCell><Chip label={item.material} size="small" color={item.material === 'Transparente' ? 'secondary' : 'primary'} /></TableCell>
                            <TableCell>{item.quantidadeUnidades.toLocaleString('pt-BR')}</TableCell>
                            <TableCell sx={{ color: '#10b981', fontWeight: 600 }}>{formatCurrency(item.precoPix)}</TableCell>
                            <TableCell sx={{ color: '#3b82f6', fontWeight: 600 }}>{formatCurrency(item.precoCartao)}</TableCell>
                            <TableCell>
                              <Tooltip title="Editar"><IconButton size="small" onClick={() => editarPacote(item.id)} color="primary"><EditIcon fontSize="small" /></IconButton></Tooltip>
                              <Tooltip title="Remover"><IconButton size="small" onClick={() => removerItem('pacote', item.id)} color="error"><DeleteIcon fontSize="small" /></IconButton></Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </TabPanel>

            {/* Aba Milheiro */}
            <TabPanel value={activeTab} index={4}>
              <CardContent sx={{ pt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Pacote (1000 un)</InputLabel>
                      <Select value={formMilheiro.pacoteId} onChange={(e) => setFormMilheiro({ ...formMilheiro, pacoteId: e.target.value })} label="Pacote (1000 un)">
                        {MILHEIRO_PACOTES.map(pac => (<MenuItem key={pac.id} value={pac.id}>{pac.nome} ({pac.quantidade}un)</MenuItem>))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <TextField fullWidth size="small" label="Qtd Pacotes" type="number" value={formMilheiro.quantidadePacotes}
                      onChange={(e) => setFormMilheiro({ ...formMilheiro, quantidadePacotes: e.target.value })} inputProps={{ min: 1 }} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Material</InputLabel>
                      <Select value={formMilheiro.material} onChange={(e) => setFormMilheiro({ ...formMilheiro, material: e.target.value })} label="Material">
                        <MenuItem value="Brilho">Brilho</MenuItem>
                        <MenuItem value="Fosco">Fosco</MenuItem>
                        <MenuItem value="Transparente">Transparente</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    {editingMilheiro ? (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button fullWidth size="small" variant="contained" color="success" onClick={salvarEdicaoMilheiro}>Salvar</Button>
                        <Button size="small" variant="outlined" color="error" onClick={cancelarEdicaoMilheiro}>Cancelar</Button>
                      </Box>
                    ) : (
                      <Button fullWidth size="small" variant="contained" startIcon={<AddIcon />} onClick={adicionarMilheiro}
                        sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}>
                        Adicionar
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField fullWidth size="small" label="Observações" value={formMilheiro.observacoes}
                      onChange={(e) => setFormMilheiro({ ...formMilheiro, observacoes: e.target.value })} />
                  </Grid>
                </Grid>

                {editingMilheiro && (<Alert severity="info" sx={{ mt: 2 }}>Editando milheiro...</Alert>)}

                {previewMilheiro.unidades > 0 && (
                  <Paper variant="outlined" sx={{ mt: 2, p: 1.5, backgroundColor: '#f8fafc' }}>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                      <Typography variant="body2" color="text.secondary">Total: <strong>{previewMilheiro.unidades.toLocaleString('pt-BR')} unidades</strong></Typography>
                      <Chip size="small" label={`PIX: ${formatCurrency(previewMilheiro.precoPix)}`} color="success" />
                      <Chip size="small" label={`Cartão: ${formatCurrency(previewMilheiro.precoCartao)}`} color="primary" />
                      <Chip size="small" label={formMilheiro.material} />
                    </Box>
                  </Paper>
                )}

                {itensMilheiro.length > 0 && (
                  <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
                    <Table size="small">
                      <TableHead sx={{ backgroundColor: '#f8fafc' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Pacote</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Qtd</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Material</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Unidades</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>PIX</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Cartão</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Ações</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {itensMilheiro.map((item) => (
                          <TableRow key={item.id} hover>
                            <TableCell>{item.pacoteNome}</TableCell>
                            <TableCell>{item.quantidadePacotes}</TableCell>
                            <TableCell><Chip label={item.material} size="small" color={item.material === 'Transparente' ? 'secondary' : 'primary'} /></TableCell>
                            <TableCell>{item.quantidadeUnidades.toLocaleString('pt-BR')}</TableCell>
                            <TableCell sx={{ color: '#10b981', fontWeight: 600 }}>{formatCurrency(item.precoPix)}</TableCell>
                            <TableCell sx={{ color: '#3b82f6', fontWeight: 600 }}>{formatCurrency(item.precoCartao)}</TableCell>
                            <TableCell>
                              <Tooltip title="Editar"><IconButton size="small" onClick={() => editarMilheiro(item.id)} color="primary"><EditIcon fontSize="small" /></IconButton></Tooltip>
                              <Tooltip title="Remover"><IconButton size="small" onClick={() => removerItem('milheiro', item.id)} color="error"><DeleteIcon fontSize="small" /></IconButton></Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </TabPanel>

            {/* Aba Sabor e Validade */}
            <TabPanel value={activeTab} index={5}>
              <CardContent sx={{ pt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Opção</InputLabel>
                      <Select value={formSaborValidade.opcaoId} onChange={(e) => setFormSaborValidade({ ...formSaborValidade, opcaoId: e.target.value })} label="Opção">
                        {SABOR_VALIDADE_OPCOES.map(op => (
                          <MenuItem key={op.id} value={op.id}>
                            {op.nome} ({op.quantidade}un) - {formatCurrency(op.precoPix)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <TextField fullWidth size="small" label="Qtd Pacotes" type="number" value={formSaborValidade.quantidadePacotes}
                      onChange={(e) => setFormSaborValidade({ ...formSaborValidade, quantidadePacotes: e.target.value })} inputProps={{ min: 1 }} />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    {editingSaborValidade ? (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button fullWidth size="small" variant="contained" color="success" onClick={salvarEdicaoSaborValidade}>Salvar</Button>
                        <Button size="small" variant="outlined" color="error" onClick={cancelarEdicaoSaborValidade}>Cancelar</Button>
                      </Box>
                    ) : (
                      <Button fullWidth size="small" variant="contained" startIcon={<AddIcon />} onClick={adicionarSaborValidade}
                        sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}>
                        Adicionar
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField fullWidth size="small" label="Observações" value={formSaborValidade.observacoes}
                      onChange={(e) => setFormSaborValidade({ ...formSaborValidade, observacoes: e.target.value })} />
                  </Grid>
                </Grid>

                {editingSaborValidade && (<Alert severity="info" sx={{ mt: 2 }}>Editando Sabor e Validade...</Alert>)}

                {previewSaborValidade.unidades > 0 && (
                  <Paper variant="outlined" sx={{ mt: 2, p: 1.5, backgroundColor: '#f8fafc' }}>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                      <Typography variant="body2" color="text.secondary">Total: <strong>{previewSaborValidade.unidades.toLocaleString('pt-BR')} unidades</strong></Typography>
                      <Chip size="small" label={`PIX: ${formatCurrency(previewSaborValidade.precoPix)}`} color="success" />
                      <Chip size="small" label={`Cartão: ${formatCurrency(previewSaborValidade.precoCartao)}`} color="primary" />
                    </Box>
                  </Paper>
                )}

                {itensSaborValidade.length > 0 && (
                  <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
                    <Table size="small">
                      <TableHead sx={{ backgroundColor: '#f8fafc' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Pacote</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Qtd</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Unidades</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>PIX</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Cartão</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Ações</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {itensSaborValidade.map((item) => (
                          <TableRow key={item.id} hover>
                            <TableCell>
                              {item.opcaoNome}
                              {item.isMilheiro && SABOR_VALIDADE_OPCOES.find(o => o.id === item.opcaoId)?.observacaoMilheiro && (
                                <Chip size="small" label={SABOR_VALIDADE_OPCOES.find(o => o.id === item.opcaoId)?.observacaoMilheiro} sx={{ ml: 1 }} color="warning" variant="outlined" />
                              )}
                            </TableCell>
                            <TableCell>{item.quantidadePacotes}</TableCell>
                            <TableCell>{item.quantidadeUnidades.toLocaleString('pt-BR')}</TableCell>
                            <TableCell sx={{ color: '#10b981', fontWeight: 600 }}>{formatCurrency(item.precoPix)}</TableCell>
                            <TableCell sx={{ color: '#3b82f6', fontWeight: 600 }}>{formatCurrency(item.precoCartao)}</TableCell>
                            <TableCell>
                              <Tooltip title="Editar"><IconButton size="small" onClick={() => editarSaborValidade(item.id)} color="primary"><EditIcon fontSize="small" /></IconButton></Tooltip>
                              <Tooltip title="Remover"><IconButton size="small" onClick={() => removerItem('saborValidade', item.id)} color="error"><DeleteIcon fontSize="small" /></IconButton></Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </TabPanel>

            {/* Lacres */}
            <TabPanel value={activeTab} index={6}>
              <CardContent sx={{ pt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={5}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Lacre</InputLabel>
                      <Select value={formLacres.opcaoId} onChange={(e) => setFormLacres({ ...formLacres, opcaoId: e.target.value })} label="Lacre">
                        {LACRES_OPCOES.map(op => (
                          <MenuItem key={op.id} value={op.id}>
                            {op.nome} ({op.quantidade.toLocaleString('pt-BR')}un) - {formatCurrency(op.precoPix)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <TextField fullWidth size="small" label="Qtd Pacotes" type="number" value={formLacres.quantidadePacotes}
                      onChange={(e) => setFormLacres({ ...formLacres, quantidadePacotes: e.target.value })} inputProps={{ min: 1 }} />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    {editingLacres ? (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button fullWidth size="small" variant="contained" color="success" onClick={salvarEdicaoLacre}>Salvar</Button>
                        <Button size="small" variant="outlined" color="error" onClick={cancelarEdicaoLacre}>Cancelar</Button>
                      </Box>
                    ) : (
                      <Button fullWidth size="small" variant="contained" startIcon={<AddIcon />} onClick={adicionarLacre}
                        sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}>
                        Adicionar
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField fullWidth size="small" label="Observações" value={formLacres.observacoes}
                      onChange={(e) => setFormLacres({ ...formLacres, observacoes: e.target.value })} />
                  </Grid>
                </Grid>

                <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'text.secondary' }}>
                  Todos os lacres são no material Brilho.
                </Typography>

                {editingLacres && (<Alert severity="info" sx={{ mt: 2 }}>Editando lacre...</Alert>)}

                {previewLacres.unidades > 0 && (
                  <Paper variant="outlined" sx={{ mt: 2, p: 1.5, backgroundColor: '#f8fafc' }}>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                      <Typography variant="body2" color="text.secondary">Total: <strong>{previewLacres.unidades.toLocaleString('pt-BR')} unidades</strong></Typography>
                      <Chip size="small" label={`PIX: ${formatCurrency(previewLacres.precoPix)}`} color="success" />
                      <Chip size="small" label={`Cartão: ${formatCurrency(previewLacres.precoCartao)}`} color="primary" />
                    </Box>
                  </Paper>
                )}

                {itensLacres.length > 0 && (
                  <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
                    <Table size="small">
                      <TableHead sx={{ backgroundColor: '#f8fafc' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Lacre</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Qtd</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Unidades</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>PIX</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Cartão</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Ações</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {itensLacres.map((item) => (
                          <TableRow key={item.id} hover>
                            <TableCell>{item.opcaoNome}</TableCell>
                            <TableCell>{item.quantidadePacotes}</TableCell>
                            <TableCell>{item.quantidadeUnidades.toLocaleString('pt-BR')}</TableCell>
                            <TableCell sx={{ color: '#10b981', fontWeight: 600 }}>{formatCurrency(item.precoPix)}</TableCell>
                            <TableCell sx={{ color: '#3b82f6', fontWeight: 600 }}>{formatCurrency(item.precoCartao)}</TableCell>
                            <TableCell>
                              <Tooltip title="Editar"><IconButton size="small" onClick={() => editarLacre(item.id)} color="primary"><EditIcon fontSize="small" /></IconButton></Tooltip>
                              <Tooltip title="Remover"><IconButton size="small" onClick={() => removerItem('lacre', item.id)} color="error"><DeleteIcon fontSize="small" /></IconButton></Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </TabPanel>
          </Card>
        </Grid>

        {/* Coluna Lateral - Totais e Frete */}
        <Grid item xs={12} lg={4}>
          {/* Card de Frete */}
          <Card elevation={0} sx={{ border: '1px solid #e5e7eb', mb: 2 }}>
            <CardContent sx={{ pb: 2 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <ShippingIcon fontSize="small" /> Frete
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Tipo</InputLabel>
                    <Select
                      value={freteOpcao}
                      onChange={(e) => setFreteOpcao(e.target.value)}
                      label="Tipo"
                    >
                      {OPCOES_FRETE.map(opt => (
                        <MenuItem key={opt.id} value={opt.id}>{opt.nome}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth size="small" label="Valor" type="number" value={freteValor}
                    onChange={(e) => setFreteValor(e.target.value)}
                    InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Card de Tipo de Orçamento */}
          <Card elevation={0} sx={{ border: '1px solid #e5e7eb', mb: 2 }}>
            <CardContent sx={{ pb: 2 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>Tipo de Orçamento</Typography>
              <FormControl fullWidth size="small">
                <Select value={tipoOrcamento} onChange={(e) => setTipoOrcamento(e.target.value)}>
                  {TIPOS_ORCAMENTO.map(tipo => (<MenuItem key={tipo} value={tipo}>{tipo}</MenuItem>))}
                </Select>
              </FormControl>
              <TextField fullWidth size="small" label="Observações Gerais" multiline rows={2} value={observacoesGerais}
                onChange={(e) => setObservacoesGerais(e.target.value)} sx={{ mt: 2 }} />
            </CardContent>
          </Card>

          {/* Card de Totais */}
          <Card elevation={0} sx={{ border: '2px solid #D4AF37', backgroundColor: '#fffef5' }}>
            <CardContent>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, textAlign: 'center', color: '#1a1a1a' }}>
                Resumo do Orçamento
              </Typography>

              <Box sx={{ mb: 2 }}>
                {itensAdesivos.length > 0 && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="body2" color="text.secondary">Adesivos ({itensAdesivos.length})</Typography>
                    <Typography variant="body2">{formatCurrency(parseFloat(totais.adesivos.pix))}</Typography>
                  </Box>
                )}
                {itensUV.length > 0 && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="body2" color="text.secondary">UV ({itensUV.length})</Typography>
                    <Typography variant="body2">{formatCurrency(parseFloat(totais.uv.pix))}</Typography>
                  </Box>
                )}
                {itensBanners.length > 0 && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="body2" color="text.secondary">Banners ({itensBanners.length})</Typography>
                    <Typography variant="body2">{formatCurrency(parseFloat(totais.banners.pix))}</Typography>
                  </Box>
                )}
                {itensPacotes.length > 0 && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="body2" color="text.secondary">Pacotes ({itensPacotes.length})</Typography>
                    <Typography variant="body2">{formatCurrency(parseFloat(totais.pacotes.pix))}</Typography>
                  </Box>
                )}
                {itensMilheiro.length > 0 && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="body2" color="text.secondary">Milheiro ({itensMilheiro.length})</Typography>
                    <Typography variant="body2">{formatCurrency(parseFloat(totais.milheiro.pix))}</Typography>
                  </Box>
                )}
                {itensSaborValidade.length > 0 && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="body2" color="text.secondary">Sabor e Validade ({itensSaborValidade.length})</Typography>
                    <Typography variant="body2">{formatCurrency(parseFloat(totais.saborValidade.pix))}</Typography>
                  </Box>
                )}
                {itensLacres.length > 0 && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="body2" color="text.secondary">Lacres ({itensLacres.length})</Typography>
                    <Typography variant="body2">{formatCurrency(parseFloat(totais.lacres.pix))}</Typography>
                  </Box>
                )}
                {totais.frete > 0 && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="body2" color="text.secondary">Frete</Typography>
                    <Typography variant="body2">{formatCurrency(totais.frete)}</Typography>
                  </Box>
                )}
              </Box>

              <Divider sx={{ my: 1.5 }} />

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="subtitle2" sx={{ color: '#10b981', fontWeight: 700 }}>PIX</Typography>
                <Typography variant="subtitle2" sx={{ color: '#10b981', fontWeight: 700 }}>{formatCurrency(totais.totalPix)}</Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="subtitle2" sx={{ color: '#3b82f6', fontWeight: 700 }}>Cartão</Typography>
                <Typography variant="subtitle2" sx={{ color: '#3b82f6', fontWeight: 700 }}>{formatCurrency(totais.totalCartao)}</Typography>
              </Box>

              {totais.totalArea > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="body2" color="text.secondary">Área Total</Typography>
                  <Typography variant="body2">{totais.totalArea.toFixed(4)} m²</Typography>
                </Box>
              )}

              {totais.totalUnidadesPacotes > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="body2" color="text.secondary">Unidades (Pacotes)</Typography>
                  <Typography variant="body2">{totais.totalUnidadesPacotes.toLocaleString('pt-BR')}</Typography>
                </Box>
              )}
              {totais.totalUnidadesMilheiro > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="body2" color="text.secondary">Unidades (Milheiro)</Typography>
                  <Typography variant="body2">{totais.totalUnidadesMilheiro.toLocaleString('pt-BR')}</Typography>
                </Box>
              )}
              {totais.totalUnidadesSaborValidade > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="body2" color="text.secondary">Unidades (Sabor e Validade)</Typography>
                  <Typography variant="body2">{totais.totalUnidadesSaborValidade.toLocaleString('pt-BR')}</Typography>
                </Box>
              )}
              {totais.totalUnidadesLacres > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="body2" color="text.secondary">Unidades (Lacres)</Typography>
                  <Typography variant="body2">{totais.totalUnidadesLacres.toLocaleString('pt-BR')}</Typography>
                </Box>
              )}

              <Button
                fullWidth
                variant="contained"
                size="small"
                startIcon={<CopyIcon />}
                onClick={gerarOrcamento}
                disabled={itensAdesivos.length === 0 && itensUV.length === 0 && itensBanners.length === 0 && itensPacotes.length === 0 && itensMilheiro.length === 0 && itensSaborValidade.length === 0 && itensLacres.length === 0}
                sx={{ mt: 2, backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}
              >
                Gerar Orçamento
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Dialog de Orçamento */}
      <Dialog open={openOrcamentoDialog} onClose={() => setOpenOrcamentoDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ fontWeight: 600 }}>Orçamento Gerado</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            multiline
            rows={18}
            value={orcamentoTexto}
            sx={{ mt: 1, '& .MuiInputBase-input': { fontFamily: 'monospace', fontSize: '13px' } }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button onClick={() => setOpenOrcamentoDialog(false)}>Fechar</Button>
          <Button variant="contained" startIcon={<CopyIcon />} onClick={copiarOrcamento}
            sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}>
            Copiar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Speed Dial - Menu Flutuante */}
      <SpeedDial
        ariaLabel="Ações rápidas"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          '& .MuiFab-primary': {
            backgroundColor: '#D4AF37',
            '&:hover': { backgroundColor: '#B8941F' },
          }
        }}
        icon={<SpeedDialIcon />}
        open={speedDialOpen}
        onOpen={() => setSpeedDialOpen(true)}
        onClose={() => setSpeedDialOpen(false)}
      >
        <SpeedDialAction
          icon={<HistoryIcon />}
          tooltipTitle="Histórico (5 últimos)"
          tooltipOpen
          onClick={() => { setDialogHistorico(true); setSpeedDialOpen(false); }}
          sx={{
            '& .MuiSpeedDialAction-staticTooltipLabel': {
              backgroundColor: '#1a1a1a',
              color: '#D4AF37',
              border: '1px solid #D4AF37',
              whiteSpace: 'nowrap',
            }
          }}
        />
        <SpeedDialAction
          icon={<BookmarkIcon />}
          tooltipTitle="Tamanhos Prontos"
          tooltipOpen
          onClick={() => { setDialogTamanhos(true); setSpeedDialOpen(false); }}
          sx={{
            '& .MuiSpeedDialAction-staticTooltipLabel': {
              backgroundColor: '#1a1a1a',
              color: '#fff',
              border: '1px solid #888',
              whiteSpace: 'nowrap',
            }
          }}
        />
        <SpeedDialAction
          icon={<SaveIcon />}
          tooltipTitle="Salvar Orçamento"
          tooltipOpen
          onClick={() => { setDialogSalvar(true); setSpeedDialOpen(false); }}
          sx={{
            '& .MuiSpeedDialAction-staticTooltipLabel': {
              backgroundColor: '#1a1a1a',
              color: '#fff',
              border: '1px solid #888',
              whiteSpace: 'nowrap',
            }
          }}
        />
      </SpeedDial>

      {/* Dialog - Histórico de Orçamentos */}
      <Dialog open={dialogHistorico} onClose={() => setDialogHistorico(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ backgroundColor: '#1a1a1a', color: '#D4AF37' }}>
          📋 Histórico de Orçamentos
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: '#1a1a1a', pt: 2 }}>
          {orcamentosSalvos.length === 0 ? (
            <Typography variant="body2" sx={{ color: '#888', py: 2 }}>
              Nenhum orçamento salvo ainda.
            </Typography>
          ) : (
            orcamentosSalvos.slice(0, 5).map((orcamento) => (
              <Paper
                key={orcamento.id}
                sx={{ mb: 1, p: 1.5, backgroundColor: '#2a2a2a', border: '1px solid #D4AF37', borderRadius: 1 }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="subtitle2" sx={{ color: '#D4AF37', fontWeight: 600 }}>
                      {orcamento.nome}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#888' }}>
                      {orcamento.dataSalvo}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button size="small" variant="contained" onClick={() => carregarOrcamento(orcamento)}
                      sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' }, fontSize: '0.7rem' }}>
                      Carregar
                    </Button>
                    <IconButton size="small" onClick={() => excluirOrcamentoCache(orcamento.id)} sx={{ color: '#f44336' }}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
              </Paper>
            ))
          )}
        </DialogContent>
        <DialogActions sx={{ backgroundColor: '#1a1a1a' }}>
          <Button onClick={() => setDialogHistorico(false)} sx={{ color: '#888' }}>Fechar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog - Tamanhos Personalizados */}
      <Dialog open={dialogTamanhos} onClose={() => setDialogTamanhos(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ backgroundColor: '#1a1a1a', color: '#D4AF37' }}>
          📐 Tamanhos Prontos
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: '#1a1a1a', pt: 2 }}>
          {/* Formulário para adicionar */}
          <Paper sx={{ p: 1.5, mb: 2, backgroundColor: '#2a2a2a', border: '1px solid #444' }}>
            <TextField fullWidth size="small" placeholder="Nome (ex: 3x3 cm)" value={novoTamanho.nome}
              onChange={(e) => setNovoTamanho({ ...novoTamanho, nome: e.target.value })}
              sx={{ mb: 1, '& .MuiInputBase-input': { color: '#fff' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }} />
            <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
              <TextField size="small" placeholder="Largura" type="number" value={novoTamanho.largura}
                onChange={(e) => setNovoTamanho({ ...novoTamanho, largura: e.target.value })}
                sx={{ flex: 1, '& .MuiInputBase-input': { color: '#fff' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }} />
              <TextField size="small" placeholder="Altura" type="number" value={novoTamanho.altura}
                onChange={(e) => setNovoTamanho({ ...novoTamanho, altura: e.target.value })}
                sx={{ flex: 1, '& .MuiInputBase-input': { color: '#fff' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }} />
              <TextField size="small" placeholder="Qtd" type="number" value={novoTamanho.quantidade}
                onChange={(e) => setNovoTamanho({ ...novoTamanho, quantidade: e.target.value })}
                sx={{ flex: 1, '& .MuiInputBase-input': { color: '#fff' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }} />
            </Box>
            <Button fullWidth variant="contained" startIcon={<AddIcon />} onClick={adicionarTamanhoPersonalizado}
              sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}>
              {editingTamanho ? 'Salvar' : 'Adicionar'}
            </Button>
          </Paper>

          {/* Lista de tamanhos */}
          {tamanhosPersonalizados.length === 0 ? (
            <Typography variant="body2" sx={{ color: '#888' }}>Nenhum tamanho personalizado.</Typography>
          ) : (
            tamanhosPersonalizados.map((tamanho) => (
              <Paper key={tamanho.id} sx={{ mb: 1, p: 1.5, backgroundColor: '#2a2a2a', border: '1px solid #D4AF37', borderRadius: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="subtitle2" sx={{ color: '#D4AF37', fontWeight: 600 }}>{tamanho.nome}</Typography>
                    <Typography variant="caption" sx={{ color: '#888' }}>{tamanho.largura} x {tamanho.altura} cm - Qtd: {tamanho.quantidade}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Button size="small" variant="outlined" onClick={() => usarTamanhoPersonalizado(tamanho)}
                      sx={{ borderColor: '#D4AF37', color: '#D4AF37', fontSize: '0.7rem', minWidth: 'auto', px: 1 }}>Usar</Button>
                    <IconButton size="small" onClick={() => editarTamanhoPersonalizado(tamanho)} sx={{ color: '#D4AF37' }}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" onClick={() => excluirTamanhoPersonalizado(tamanho.id)} sx={{ color: '#f44336' }}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
              </Paper>
            ))
          )}
        </DialogContent>
        <DialogActions sx={{ backgroundColor: '#1a1a1a' }}>
          <Button onClick={() => setDialogTamanhos(false)} sx={{ color: '#888' }}>Fechar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog - Salvar Orçamento */}
      <Dialog open={dialogSalvar} onClose={() => setDialogSalvar(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ backgroundColor: '#1a1a1a', color: '#D4AF37' }}>
          💾 Salvar Orçamento
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: '#1a1a1a', pt: 2 }}>
          <TextField fullWidth size="small" placeholder="Nome do orçamento" value={nomeOrcamento}
            onChange={(e) => setNomeOrcamento(e.target.value)}
            sx={{ mb: 2, '& .MuiInputBase-input': { color: '#fff' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }} />
          <Typography variant="caption" sx={{ color: '#888' }}>
            Itens: {itensAdesivos.length + itensUV.length + itensBanners.length + itensPacotes.length}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: '#1a1a1a' }}>
          <Button onClick={() => setDialogSalvar(false)} sx={{ color: '#888' }}>Cancelar</Button>
          <Button variant="contained" startIcon={<SaveIcon />} onClick={salvarOrcamentoCache}
            disabled={itensAdesivos.length + itensUV.length + itensBanners.length + itensPacotes.length === 0}
            sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B8941F' } }}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default QuickQuote;



